webpackJsonp([71833740541355],{

/***/ 1117:
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 301);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(1);
	
	/***/ }),
	
	/***/ 1:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(3);
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(17);
	
	/***/ }),
	
	/***/ 301:
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Tooltip = __webpack_require__(302);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Tooltip2.default;
	
	/***/ }),
	
	/***/ 302:
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(0);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bind = __webpack_require__(3);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _reactTether = __webpack_require__(303);
	
	var _reactTether2 = _interopRequireDefault(_reactTether);
	
	var _Caret = __webpack_require__(304);
	
	var _Caret2 = _interopRequireDefault(_Caret);
	
	var _size = __webpack_require__(305);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _general = __webpack_require__(306);
	
	var _general2 = _interopRequireDefault(_general);
	
	var _type = __webpack_require__(307);
	
	var _type2 = _interopRequireDefault(_type);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tooltipStyle = _extends({}, _size2.default, _general2.default, _type2.default);
	var cx = _bind2.default.bind(tooltipStyle);
	
	var tooltipPosition = ['top left', 'top center', 'top right', 'middle left', 'middle center', 'middle right', 'bottom left', 'bottom center', 'bottom right'];
	
	var customClasses = getCustomClasses();
	
	var Tooltip = function (_Component) {
	  _inherits(Tooltip, _Component);
	
	  function Tooltip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hover: false
	    }, _this.invertHover = function () {
	      _this.setState({ hover: !_this.state.hover });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Tooltip, [{
	    key: 'render',
	    value: function render() {
	      var hover = this.state.hover;
	
	
	      var tooltipClasses = cx('tooltip', this.props.size, this.props.type);
	
	      var caretClasses = cx('caret', 'caret-' + this.props.type);
	
	      return _react2.default.createElement(
	        _reactTether2.default,
	        {
	          attachment: this.props.position,
	          constraints: [{
	            to: 'window',
	            attachment: 'together'
	          }],
	          classes: customClasses
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            className: _general2.default.container,
	            onMouseOver: this.invertHover,
	            onMouseOut: this.invertHover
	          },
	          this.props.children
	        ),
	        hover && _react2.default.createElement(
	          'div',
	          { className: _general2.default.wrap },
	          _react2.default.createElement(
	            'div',
	            { className: tooltipClasses },
	            this.props.text,
	            _react2.default.createElement(
	              'div',
	              { className: caretClasses },
	              _react2.default.createElement(_Caret2.default, null)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Tooltip;
	}(_react.Component);
	
	exports.default = Tooltip;
	
	
	Tooltip.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  position: _propTypes2.default.oneOf(tooltipPosition).isRequired,
	  size: _propTypes2.default.oneOf(Object.keys(_size2.default)).isRequired,
	  text: _propTypes2.default.string.isRequired,
	  type: _propTypes2.default.oneOf(Object.keys(_type2.default)).isRequired
	};
	
	Tooltip.defaultProps = {
	  position: 'bottom center',
	  size: 'medium',
	  type: 'dark'
	};
	
	function getCustomClasses() {
	  return ['bottom', 'top', 'left', 'right', 'middle', 'center'].reduce(function (classes, pos) {
	    /* eslint-disable no-param-reassign */
	    classes[getDefaultClass(pos)] = _general2.default[pos];
	    return classes;
	  }, {});
	}
	
	function getDefaultClass(position) {
	  return 'element-attached-' + position;
	}
	
	/***/ }),
	
	/***/ 303:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(2404);
	
	/***/ }),
	
	/***/ 304:
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Caret;
	
	var _react = __webpack_require__(0);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Caret() {
	  return _react2.default.createElement(
	    "svg",
	    { className: "display-block", width: "10", height: "4", viewBox: "0 0 10 4" },
	    _react2.default.createElement("path", { d: "M0,0H10L5.62,3.78a1,1,0,0,1-1.25,0Z" })
	  );
	}
	
	/***/ }),
	
	/***/ 305:
	/***/ (function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	module.exports = {"small":"size__small___3_PPZ borderRadius-s fontSize-xs lineHeight-s paddingLeftRight-xxs","medium":"size__medium___sClcu borderRadius-s fontSize-s lineHeight-m paddingLeftRight-xs"};
	
	/***/ }),
	
	/***/ 306:
	/***/ (function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	module.exports = {"container":"general__container___1thju display-inlineBlock position-relative","tooltip":"general__tooltip____n1SX whiteSpace-nowrap position-relative","wrap":"general__wrap___2xAbq padding-xxs","caret":"general__caret___3uXnm position-absolute","caret-dark":"general__caret-dark___1T6YA fill-black--translucent","caret-light":"general__caret-light___vmJgq fill-white--translucent","caret-black":"general__caret-black___-tb_e fill-licorice--translucent","bottom":"general__bottom___3U8s4","top":"general__top___2JmeE","left":"general__left___3VNOF","right":"general__right___2xmnx","middle":"general__middle___3kt66","center":"general__center___29cb_"};
	
	/***/ }),
	
	/***/ 307:
	/***/ (function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	module.exports = {"dark":"type__dark___2mIFH bg-black--translucent c-white","light":"type__light___HV8pF bg-white--translucent c-slate","black":"type__black___Avzqc bg-licorice--translucent c-white"};
	
	/***/ })
	
	/******/ });
	//# sourceMappingURL=marvel-ui-tooltip.js.map

/***/ }),

/***/ 1119:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1117);


/***/ }),

/***/ 2403:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(60);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _tether = __webpack_require__(2503);
	
	var _tether2 = _interopRequireDefault(_tether);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	if (!_tether2.default) {
	  console.error('It looks like Tether has not been included. Please load this dependency first https://github.com/HubSpot/tether');
	}
	
	var renderElementToPropTypes = [_propTypes2.default.string, _propTypes2.default.shape({
	  appendChild: _propTypes2.default.func.isRequired
	})];
	
	var childrenPropType = function childrenPropType(_ref, propName, componentName) {
	  var children = _ref.children;
	
	  var childCount = _react.Children.count(children);
	  if (childCount <= 0) {
	    return new Error(componentName + ' expects at least one child to use as the target element.');
	  } else if (childCount > 2) {
	    return new Error('Only a max of two children allowed in ' + componentName + '.');
	  }
	};
	
	var attachmentPositions = ['auto auto', 'top left', 'top center', 'top right', 'middle left', 'middle center', 'middle right', 'bottom left', 'bottom center', 'bottom right'];
	
	var TetherComponent = function (_Component) {
	  _inherits(TetherComponent, _Component);
	
	  function TetherComponent() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TetherComponent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = TetherComponent.__proto__ || Object.getPrototypeOf(TetherComponent)).call.apply(_ref2, [this].concat(args))), _this), _this._targetNode = null, _this._elementParentNode = null, _this._tether = false, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TetherComponent, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._targetNode = _reactDom2.default.findDOMNode(this);
	      this._update();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      this._targetNode = _reactDom2.default.findDOMNode(this);
	      this._update();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._destroy();
	    }
	  }, {
	    key: 'getTetherInstance',
	    value: function getTetherInstance() {
	      return this._tether;
	    }
	  }, {
	    key: 'disable',
	    value: function disable() {
	      this._tether.disable();
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      this._tether.enable();
	    }
	  }, {
	    key: 'on',
	    value: function on(event, handler, ctx) {
	      this._tether.on(event, handler, ctx);
	    }
	  }, {
	    key: 'once',
	    value: function once(event, handler, ctx) {
	      this._tether.once(event, handler, ctx);
	    }
	  }, {
	    key: 'off',
	    value: function off(event, handler) {
	      this._tether.off(event, handler);
	    }
	  }, {
	    key: 'position',
	    value: function position() {
	      this._tether.position();
	    }
	  }, {
	    key: '_registerEventListeners',
	    value: function _registerEventListeners() {
	      var _this2 = this,
	          _arguments = arguments;
	
	      this.on('update', function () {
	        return _this2.props.onUpdate && _this2.props.onUpdate.apply(_this2, _arguments);
	      });
	
	      this.on('repositioned', function () {
	        return _this2.props.onRepositioned && _this2.props.onRepositioned.apply(_this2, _arguments);
	      });
	    }
	  }, {
	    key: '_destroy',
	    value: function _destroy() {
	      if (this._elementParentNode) {
	        _reactDom2.default.unmountComponentAtNode(this._elementParentNode);
	        this._elementParentNode.parentNode.removeChild(this._elementParentNode);
	      }
	
	      if (this._tether) {
	        this._tether.destroy();
	      }
	
	      this._elementParentNode = null;
	      this._tether = null;
	    }
	  }, {
	    key: '_update',
	    value: function _update() {
	      var _this3 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          renderElementTag = _props.renderElementTag;
	
	      var elementComponent = _react.Children.toArray(children)[1];
	
	      // if no element component provided, bail out
	      if (!elementComponent) {
	        // destroy Tether element if it has been created
	        if (this._tether) {
	          this._destroy();
	        }
	        return;
	      }
	
	      // create element node container if it hasn't been yet
	      if (!this._elementParentNode) {
	        // create a node that we can stick our content Component in
	        this._elementParentNode = document.createElement(renderElementTag);
	
	        // append node to the render node
	        this._renderNode.appendChild(this._elementParentNode);
	      }
	
	      // render element component into the DOM
	      _reactDom2.default.unstable_renderSubtreeIntoContainer(this, elementComponent, this._elementParentNode, function () {
	        // if we're not destroyed, update Tether once the subtree has finished rendering
	        if (_this3._elementParentNode) {
	          _this3._updateTether();
	        }
	      });
	    }
	  }, {
	    key: '_updateTether',
	    value: function _updateTether() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          renderElementTag = _props2.renderElementTag,
	          renderElementTo = _props2.renderElementTo,
	          id = _props2.id,
	          className = _props2.className,
	          style = _props2.style,
	          options = _objectWithoutProperties(_props2, ['children', 'renderElementTag', 'renderElementTo', 'id', 'className', 'style']);
	
	      var tetherOptions = _extends({
	        target: this._targetNode,
	        element: this._elementParentNode
	      }, options);
	
	      if (id) {
	        this._elementParentNode.id = id;
	      }
	
	      if (className) {
	        this._elementParentNode.className = className;
	      }
	
	      if (style) {
	        Object.keys(style).forEach(function (key) {
	          _this4._elementParentNode.style[key] = style[key];
	        });
	      }
	
	      if (!this._tether) {
	        this._tether = new _tether2.default(tetherOptions);
	        this._registerEventListeners();
	      } else {
	        this._tether.setOptions(tetherOptions);
	      }
	
	      this._tether.position();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react.Children.toArray(this.props.children)[0];
	    }
	  }, {
	    key: '_renderNode',
	    get: function get() {
	      var renderElementTo = this.props.renderElementTo;
	
	      if (typeof renderElementTo === 'string') {
	        return document.querySelector(renderElementTo);
	      } else {
	        return renderElementTo || document.body;
	      }
	    }
	  }]);
	
	  return TetherComponent;
	}(_react.Component);
	
	TetherComponent.propTypes = {
	  renderElementTag: _propTypes2.default.string,
	  renderElementTo: _propTypes2.default.oneOfType(renderElementToPropTypes),
	  attachment: _propTypes2.default.oneOf(attachmentPositions).isRequired,
	  targetAttachment: _propTypes2.default.oneOf(attachmentPositions),
	  offset: _propTypes2.default.string,
	  targetOffset: _propTypes2.default.string,
	  targetModifier: _propTypes2.default.string,
	  enabled: _propTypes2.default.bool,
	  classes: _propTypes2.default.object,
	  classPrefix: _propTypes2.default.string,
	  optimizations: _propTypes2.default.object,
	  constraints: _propTypes2.default.array,
	  id: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  onUpdate: _propTypes2.default.func,
	  onRepositioned: _propTypes2.default.func,
	  children: childrenPropType
	};
	TetherComponent.defaultProps = {
	  renderElementTag: 'div',
	  renderElementTo: null
	};
	exports.default = TetherComponent;
	module.exports = exports['default'];

/***/ }),

/***/ 2404:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TetherComponent = __webpack_require__(2403);
	
	var _TetherComponent2 = _interopRequireDefault(_TetherComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TetherComponent2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 2503:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! tether 1.4.0 */
	
	(function(root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory(require, exports, module);
	  } else {
	    root.Tether = factory();
	  }
	}(this, function(require, exports, module) {
	
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var TetherBase = undefined;
	if (typeof TetherBase === 'undefined') {
	  TetherBase = { modules: [] };
	}
	
	var zeroElement = null;
	
	// Same as native getBoundingClientRect, except it takes into account parent <frame> offsets
	// if the element lies within a nested document (<frame> or <iframe>-like).
	function getActualBoundingClientRect(node) {
	  var boundingRect = node.getBoundingClientRect();
	
	  // The original object returned by getBoundingClientRect is immutable, so we clone it
	  // We can't use extend because the properties are not considered part of the object by hasOwnProperty in IE9
	  var rect = {};
	  for (var k in boundingRect) {
	    rect[k] = boundingRect[k];
	  }
	
	  if (node.ownerDocument !== document) {
	    var _frameElement = node.ownerDocument.defaultView.frameElement;
	    if (_frameElement) {
	      var frameRect = getActualBoundingClientRect(_frameElement);
	      rect.top += frameRect.top;
	      rect.bottom += frameRect.top;
	      rect.left += frameRect.left;
	      rect.right += frameRect.left;
	    }
	  }
	
	  return rect;
	}
	
	function getScrollParents(el) {
	  // In firefox if the el is inside an iframe with display: none; window.getComputedStyle() will return null;
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	  var computedStyle = getComputedStyle(el) || {};
	  var position = computedStyle.position;
	  var parents = [];
	
	  if (position === 'fixed') {
	    return [el];
	  }
	
	  var parent = el;
	  while ((parent = parent.parentNode) && parent && parent.nodeType === 1) {
	    var style = undefined;
	    try {
	      style = getComputedStyle(parent);
	    } catch (err) {}
	
	    if (typeof style === 'undefined' || style === null) {
	      parents.push(parent);
	      return parents;
	    }
	
	    var _style = style;
	    var overflow = _style.overflow;
	    var overflowX = _style.overflowX;
	    var overflowY = _style.overflowY;
	
	    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	      if (position !== 'absolute' || ['relative', 'absolute', 'fixed'].indexOf(style.position) >= 0) {
	        parents.push(parent);
	      }
	    }
	  }
	
	  parents.push(el.ownerDocument.body);
	
	  // If the node is within a frame, account for the parent window scroll
	  if (el.ownerDocument !== document) {
	    parents.push(el.ownerDocument.defaultView);
	  }
	
	  return parents;
	}
	
	var uniqueId = (function () {
	  var id = 0;
	  return function () {
	    return ++id;
	  };
	})();
	
	var zeroPosCache = {};
	var getOrigin = function getOrigin() {
	  // getBoundingClientRect is unfortunately too accurate.  It introduces a pixel or two of
	  // jitter as the user scrolls that messes with our ability to detect if two positions
	  // are equivilant or not.  We place an element at the top left of the page that will
	  // get the same jitter, so we can cancel the two out.
	  var node = zeroElement;
	  if (!node || !document.body.contains(node)) {
	    node = document.createElement('div');
	    node.setAttribute('data-tether-id', uniqueId());
	    extend(node.style, {
	      top: 0,
	      left: 0,
	      position: 'absolute'
	    });
	
	    document.body.appendChild(node);
	
	    zeroElement = node;
	  }
	
	  var id = node.getAttribute('data-tether-id');
	  if (typeof zeroPosCache[id] === 'undefined') {
	    zeroPosCache[id] = getActualBoundingClientRect(node);
	
	    // Clear the cache when this position call is done
	    defer(function () {
	      delete zeroPosCache[id];
	    });
	  }
	
	  return zeroPosCache[id];
	};
	
	function removeUtilElements() {
	  if (zeroElement) {
	    document.body.removeChild(zeroElement);
	  }
	  zeroElement = null;
	};
	
	function getBounds(el) {
	  var doc = undefined;
	  if (el === document) {
	    doc = document;
	    el = document.documentElement;
	  } else {
	    doc = el.ownerDocument;
	  }
	
	  var docEl = doc.documentElement;
	
	  var box = getActualBoundingClientRect(el);
	
	  var origin = getOrigin();
	
	  box.top -= origin.top;
	  box.left -= origin.left;
	
	  if (typeof box.width === 'undefined') {
	    box.width = document.body.scrollWidth - box.left - box.right;
	  }
	  if (typeof box.height === 'undefined') {
	    box.height = document.body.scrollHeight - box.top - box.bottom;
	  }
	
	  box.top = box.top - docEl.clientTop;
	  box.left = box.left - docEl.clientLeft;
	  box.right = doc.body.clientWidth - box.width - box.left;
	  box.bottom = doc.body.clientHeight - box.height - box.top;
	
	  return box;
	}
	
	function getOffsetParent(el) {
	  return el.offsetParent || document.documentElement;
	}
	
	var _scrollBarSize = null;
	function getScrollBarSize() {
	  if (_scrollBarSize) {
	    return _scrollBarSize;
	  }
	  var inner = document.createElement('div');
	  inner.style.width = '100%';
	  inner.style.height = '200px';
	
	  var outer = document.createElement('div');
	  extend(outer.style, {
	    position: 'absolute',
	    top: 0,
	    left: 0,
	    pointerEvents: 'none',
	    visibility: 'hidden',
	    width: '200px',
	    height: '150px',
	    overflow: 'hidden'
	  });
	
	  outer.appendChild(inner);
	
	  document.body.appendChild(outer);
	
	  var widthContained = inner.offsetWidth;
	  outer.style.overflow = 'scroll';
	  var widthScroll = inner.offsetWidth;
	
	  if (widthContained === widthScroll) {
	    widthScroll = outer.clientWidth;
	  }
	
	  document.body.removeChild(outer);
	
	  var width = widthContained - widthScroll;
	
	  _scrollBarSize = { width: width, height: width };
	  return _scrollBarSize;
	}
	
	function extend() {
	  var out = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  var args = [];
	
	  Array.prototype.push.apply(args, arguments);
	
	  args.slice(1).forEach(function (obj) {
	    if (obj) {
	      for (var key in obj) {
	        if (({}).hasOwnProperty.call(obj, key)) {
	          out[key] = obj[key];
	        }
	      }
	    }
	  });
	
	  return out;
	}
	
	function removeClass(el, name) {
	  if (typeof el.classList !== 'undefined') {
	    name.split(' ').forEach(function (cls) {
	      if (cls.trim()) {
	        el.classList.remove(cls);
	      }
	    });
	  } else {
	    var regex = new RegExp('(^| )' + name.split(' ').join('|') + '( |$)', 'gi');
	    var className = getClassName(el).replace(regex, ' ');
	    setClassName(el, className);
	  }
	}
	
	function addClass(el, name) {
	  if (typeof el.classList !== 'undefined') {
	    name.split(' ').forEach(function (cls) {
	      if (cls.trim()) {
	        el.classList.add(cls);
	      }
	    });
	  } else {
	    removeClass(el, name);
	    var cls = getClassName(el) + (' ' + name);
	    setClassName(el, cls);
	  }
	}
	
	function hasClass(el, name) {
	  if (typeof el.classList !== 'undefined') {
	    return el.classList.contains(name);
	  }
	  var className = getClassName(el);
	  return new RegExp('(^| )' + name + '( |$)', 'gi').test(className);
	}
	
	function getClassName(el) {
	  // Can't use just SVGAnimatedString here since nodes within a Frame in IE have
	  // completely separately SVGAnimatedString base classes
	  if (el.className instanceof el.ownerDocument.defaultView.SVGAnimatedString) {
	    return el.className.baseVal;
	  }
	  return el.className;
	}
	
	function setClassName(el, className) {
	  el.setAttribute('class', className);
	}
	
	function updateClasses(el, add, all) {
	  // Of the set of 'all' classes, we need the 'add' classes, and only the
	  // 'add' classes to be set.
	  all.forEach(function (cls) {
	    if (add.indexOf(cls) === -1 && hasClass(el, cls)) {
	      removeClass(el, cls);
	    }
	  });
	
	  add.forEach(function (cls) {
	    if (!hasClass(el, cls)) {
	      addClass(el, cls);
	    }
	  });
	}
	
	var deferred = [];
	
	var defer = function defer(fn) {
	  deferred.push(fn);
	};
	
	var flush = function flush() {
	  var fn = undefined;
	  while (fn = deferred.pop()) {
	    fn();
	  }
	};
	
	var Evented = (function () {
	  function Evented() {
	    _classCallCheck(this, Evented);
	  }
	
	  _createClass(Evented, [{
	    key: 'on',
	    value: function on(event, handler, ctx) {
	      var once = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
	      if (typeof this.bindings === 'undefined') {
	        this.bindings = {};
	      }
	      if (typeof this.bindings[event] === 'undefined') {
	        this.bindings[event] = [];
	      }
	      this.bindings[event].push({ handler: handler, ctx: ctx, once: once });
	    }
	  }, {
	    key: 'once',
	    value: function once(event, handler, ctx) {
	      this.on(event, handler, ctx, true);
	    }
	  }, {
	    key: 'off',
	    value: function off(event, handler) {
	      if (typeof this.bindings === 'undefined' || typeof this.bindings[event] === 'undefined') {
	        return;
	      }
	
	      if (typeof handler === 'undefined') {
	        delete this.bindings[event];
	      } else {
	        var i = 0;
	        while (i < this.bindings[event].length) {
	          if (this.bindings[event][i].handler === handler) {
	            this.bindings[event].splice(i, 1);
	          } else {
	            ++i;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'trigger',
	    value: function trigger(event) {
	      if (typeof this.bindings !== 'undefined' && this.bindings[event]) {
	        var i = 0;
	
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        while (i < this.bindings[event].length) {
	          var _bindings$event$i = this.bindings[event][i];
	          var handler = _bindings$event$i.handler;
	          var ctx = _bindings$event$i.ctx;
	          var once = _bindings$event$i.once;
	
	          var context = ctx;
	          if (typeof context === 'undefined') {
	            context = this;
	          }
	
	          handler.apply(context, args);
	
	          if (once) {
	            this.bindings[event].splice(i, 1);
	          } else {
	            ++i;
	          }
	        }
	      }
	    }
	  }]);
	
	  return Evented;
	})();
	
	TetherBase.Utils = {
	  getActualBoundingClientRect: getActualBoundingClientRect,
	  getScrollParents: getScrollParents,
	  getBounds: getBounds,
	  getOffsetParent: getOffsetParent,
	  extend: extend,
	  addClass: addClass,
	  removeClass: removeClass,
	  hasClass: hasClass,
	  updateClasses: updateClasses,
	  defer: defer,
	  flush: flush,
	  uniqueId: uniqueId,
	  Evented: Evented,
	  getScrollBarSize: getScrollBarSize,
	  removeUtilElements: removeUtilElements
	};
	/* globals TetherBase, performance */
	
	'use strict';
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x7, _x8, _x9) { var _again = true; _function: while (_again) { var object = _x7, property = _x8, receiver = _x9; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x7 = parent; _x8 = property; _x9 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	if (typeof TetherBase === 'undefined') {
	  throw new Error('You must include the utils.js file before tether.js');
	}
	
	var _TetherBase$Utils = TetherBase.Utils;
	var getScrollParents = _TetherBase$Utils.getScrollParents;
	var getBounds = _TetherBase$Utils.getBounds;
	var getOffsetParent = _TetherBase$Utils.getOffsetParent;
	var extend = _TetherBase$Utils.extend;
	var addClass = _TetherBase$Utils.addClass;
	var removeClass = _TetherBase$Utils.removeClass;
	var updateClasses = _TetherBase$Utils.updateClasses;
	var defer = _TetherBase$Utils.defer;
	var flush = _TetherBase$Utils.flush;
	var getScrollBarSize = _TetherBase$Utils.getScrollBarSize;
	var removeUtilElements = _TetherBase$Utils.removeUtilElements;
	
	function within(a, b) {
	  var diff = arguments.length <= 2 || arguments[2] === undefined ? 1 : arguments[2];
	
	  return a + diff >= b && b >= a - diff;
	}
	
	var transformKey = (function () {
	  if (typeof document === 'undefined') {
	    return '';
	  }
	  var el = document.createElement('div');
	
	  var transforms = ['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform'];
	  for (var i = 0; i < transforms.length; ++i) {
	    var key = transforms[i];
	    if (el.style[key] !== undefined) {
	      return key;
	    }
	  }
	})();
	
	var tethers = [];
	
	var position = function position() {
	  tethers.forEach(function (tether) {
	    tether.position(false);
	  });
	  flush();
	};
	
	function now() {
	  if (typeof performance !== 'undefined' && typeof performance.now !== 'undefined') {
	    return performance.now();
	  }
	  return +new Date();
	}
	
	(function () {
	  var lastCall = null;
	  var lastDuration = null;
	  var pendingTimeout = null;
	
	  var tick = function tick() {
	    if (typeof lastDuration !== 'undefined' && lastDuration > 16) {
	      // We voluntarily throttle ourselves if we can't manage 60fps
	      lastDuration = Math.min(lastDuration - 16, 250);
	
	      // Just in case this is the last event, remember to position just once more
	      pendingTimeout = setTimeout(tick, 250);
	      return;
	    }
	
	    if (typeof lastCall !== 'undefined' && now() - lastCall < 10) {
	      // Some browsers call events a little too frequently, refuse to run more than is reasonable
	      return;
	    }
	
	    if (pendingTimeout != null) {
	      clearTimeout(pendingTimeout);
	      pendingTimeout = null;
	    }
	
	    lastCall = now();
	    position();
	    lastDuration = now() - lastCall;
	  };
	
	  if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined') {
	    ['resize', 'scroll', 'touchmove'].forEach(function (event) {
	      window.addEventListener(event, tick);
	    });
	  }
	})();
	
	var MIRROR_LR = {
	  center: 'center',
	  left: 'right',
	  right: 'left'
	};
	
	var MIRROR_TB = {
	  middle: 'middle',
	  top: 'bottom',
	  bottom: 'top'
	};
	
	var OFFSET_MAP = {
	  top: 0,
	  left: 0,
	  middle: '50%',
	  center: '50%',
	  bottom: '100%',
	  right: '100%'
	};
	
	var autoToFixedAttachment = function autoToFixedAttachment(attachment, relativeToAttachment) {
	  var left = attachment.left;
	  var top = attachment.top;
	
	  if (left === 'auto') {
	    left = MIRROR_LR[relativeToAttachment.left];
	  }
	
	  if (top === 'auto') {
	    top = MIRROR_TB[relativeToAttachment.top];
	  }
	
	  return { left: left, top: top };
	};
	
	var attachmentToOffset = function attachmentToOffset(attachment) {
	  var left = attachment.left;
	  var top = attachment.top;
	
	  if (typeof OFFSET_MAP[attachment.left] !== 'undefined') {
	    left = OFFSET_MAP[attachment.left];
	  }
	
	  if (typeof OFFSET_MAP[attachment.top] !== 'undefined') {
	    top = OFFSET_MAP[attachment.top];
	  }
	
	  return { left: left, top: top };
	};
	
	function addOffset() {
	  var out = { top: 0, left: 0 };
	
	  for (var _len = arguments.length, offsets = Array(_len), _key = 0; _key < _len; _key++) {
	    offsets[_key] = arguments[_key];
	  }
	
	  offsets.forEach(function (_ref) {
	    var top = _ref.top;
	    var left = _ref.left;
	
	    if (typeof top === 'string') {
	      top = parseFloat(top, 10);
	    }
	    if (typeof left === 'string') {
	      left = parseFloat(left, 10);
	    }
	
	    out.top += top;
	    out.left += left;
	  });
	
	  return out;
	}
	
	function offsetToPx(offset, size) {
	  if (typeof offset.left === 'string' && offset.left.indexOf('%') !== -1) {
	    offset.left = parseFloat(offset.left, 10) / 100 * size.width;
	  }
	  if (typeof offset.top === 'string' && offset.top.indexOf('%') !== -1) {
	    offset.top = parseFloat(offset.top, 10) / 100 * size.height;
	  }
	
	  return offset;
	}
	
	var parseOffset = function parseOffset(value) {
	  var _value$split = value.split(' ');
	
	  var _value$split2 = _slicedToArray(_value$split, 2);
	
	  var top = _value$split2[0];
	  var left = _value$split2[1];
	
	  return { top: top, left: left };
	};
	var parseAttachment = parseOffset;
	
	var TetherClass = (function (_Evented) {
	  _inherits(TetherClass, _Evented);
	
	  function TetherClass(options) {
	    var _this = this;
	
	    _classCallCheck(this, TetherClass);
	
	    _get(Object.getPrototypeOf(TetherClass.prototype), 'constructor', this).call(this);
	    this.position = this.position.bind(this);
	
	    tethers.push(this);
	
	    this.history = [];
	
	    this.setOptions(options, false);
	
	    TetherBase.modules.forEach(function (module) {
	      if (typeof module.initialize !== 'undefined') {
	        module.initialize.call(_this);
	      }
	    });
	
	    this.position();
	  }
	
	  _createClass(TetherClass, [{
	    key: 'getClass',
	    value: function getClass() {
	      var key = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
	      var modifier = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];
	      var classes = this.options.classes;
	
	      var cls = '';
	
	      if (typeof classes !== 'undefined' && this.options.classes[key + '-' + modifier]) {
	        cls += this.options.classes[key + '-' + modifier];
	      } else if (typeof classes !== 'undefined' && this.options.classes[key] && modifier) {
	        cls += this.options.classes[key] + '-' + modifier;
	      } else if (typeof classes !== 'undefined' && this.options.classes[key]) {
	        cls += this.options.classes[key];
	      } else {
	        if (this.options.classPrefix) {
	          cls += this.options.classPrefix + '-';
	        }
	
	        cls += key;
	
	        if (modifier) {
	          cls += '-' + modifier;
	        }
	      }
	
	      return cls;
	    }
	  }, {
	    key: 'setOptions',
	    value: function setOptions(options) {
	      var _this2 = this;
	
	      var pos = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	      var defaults = {
	        offset: '0 0',
	        targetOffset: '0 0',
	        targetAttachment: 'auto auto',
	        classPrefix: 'tether'
	      };
	
	      this.options = extend(defaults, options);
	
	      var _options = this.options;
	      var element = _options.element;
	      var target = _options.target;
	      var targetModifier = _options.targetModifier;
	
	      this.element = element;
	      this.target = target;
	      this.targetModifier = targetModifier;
	
	      if (this.target === 'viewport') {
	        this.target = document.body;
	        this.targetModifier = 'visible';
	      } else if (this.target === 'scroll-handle') {
	        this.target = document.body;
	        this.targetModifier = 'scroll-handle';
	      }
	
	      ['element', 'target'].forEach(function (key) {
	        if (typeof _this2[key] === 'undefined') {
	          throw new Error('Tether Error: Both element and target must be defined');
	        }
	
	        if (typeof _this2[key].jquery !== 'undefined') {
	          _this2[key] = _this2[key][0];
	        } else if (typeof _this2[key] === 'string') {
	          _this2[key] = document.querySelector(_this2[key]);
	        }
	      });
	
	      addClass(this.element, this.getClass('element'));
	      if (!(this.options.addTargetClasses === false)) {
	        addClass(this.target, this.getClass('target'));
	      }
	
	      if (!this.options.attachment) {
	        throw new Error('Tether Error: You must provide an attachment');
	      }
	
	      this.targetAttachment = parseAttachment(this.options.targetAttachment);
	      this.attachment = parseAttachment(this.options.attachment);
	      this.offset = parseOffset(this.options.offset);
	      this.targetOffset = parseOffset(this.options.targetOffset);
	
	      if (typeof this.scrollParents !== 'undefined') {
	        this.disable();
	      }
	
	      if (this.targetModifier === 'scroll-handle') {
	        this.scrollParents = [this.target];
	      } else {
	        this.scrollParents = getScrollParents(this.target);
	      }
	
	      if (!(this.options.enabled === false)) {
	        this.enable(pos);
	      }
	    }
	  }, {
	    key: 'getTargetBounds',
	    value: function getTargetBounds() {
	      if (typeof this.targetModifier !== 'undefined') {
	        if (this.targetModifier === 'visible') {
	          if (this.target === document.body) {
	            return { top: pageYOffset, left: pageXOffset, height: innerHeight, width: innerWidth };
	          } else {
	            var bounds = getBounds(this.target);
	
	            var out = {
	              height: bounds.height,
	              width: bounds.width,
	              top: bounds.top,
	              left: bounds.left
	            };
	
	            out.height = Math.min(out.height, bounds.height - (pageYOffset - bounds.top));
	            out.height = Math.min(out.height, bounds.height - (bounds.top + bounds.height - (pageYOffset + innerHeight)));
	            out.height = Math.min(innerHeight, out.height);
	            out.height -= 2;
	
	            out.width = Math.min(out.width, bounds.width - (pageXOffset - bounds.left));
	            out.width = Math.min(out.width, bounds.width - (bounds.left + bounds.width - (pageXOffset + innerWidth)));
	            out.width = Math.min(innerWidth, out.width);
	            out.width -= 2;
	
	            if (out.top < pageYOffset) {
	              out.top = pageYOffset;
	            }
	            if (out.left < pageXOffset) {
	              out.left = pageXOffset;
	            }
	
	            return out;
	          }
	        } else if (this.targetModifier === 'scroll-handle') {
	          var bounds = undefined;
	          var target = this.target;
	          if (target === document.body) {
	            target = document.documentElement;
	
	            bounds = {
	              left: pageXOffset,
	              top: pageYOffset,
	              height: innerHeight,
	              width: innerWidth
	            };
	          } else {
	            bounds = getBounds(target);
	          }
	
	          var style = getComputedStyle(target);
	
	          var hasBottomScroll = target.scrollWidth > target.clientWidth || [style.overflow, style.overflowX].indexOf('scroll') >= 0 || this.target !== document.body;
	
	          var scrollBottom = 0;
	          if (hasBottomScroll) {
	            scrollBottom = 15;
	          }
	
	          var height = bounds.height - parseFloat(style.borderTopWidth) - parseFloat(style.borderBottomWidth) - scrollBottom;
	
	          var out = {
	            width: 15,
	            height: height * 0.975 * (height / target.scrollHeight),
	            left: bounds.left + bounds.width - parseFloat(style.borderLeftWidth) - 15
	          };
	
	          var fitAdj = 0;
	          if (height < 408 && this.target === document.body) {
	            fitAdj = -0.00011 * Math.pow(height, 2) - 0.00727 * height + 22.58;
	          }
	
	          if (this.target !== document.body) {
	            out.height = Math.max(out.height, 24);
	          }
	
	          var scrollPercentage = this.target.scrollTop / (target.scrollHeight - height);
	          out.top = scrollPercentage * (height - out.height - fitAdj) + bounds.top + parseFloat(style.borderTopWidth);
	
	          if (this.target === document.body) {
	            out.height = Math.max(out.height, 24);
	          }
	
	          return out;
	        }
	      } else {
	        return getBounds(this.target);
	      }
	    }
	  }, {
	    key: 'clearCache',
	    value: function clearCache() {
	      this._cache = {};
	    }
	  }, {
	    key: 'cache',
	    value: function cache(k, getter) {
	      // More than one module will often need the same DOM info, so
	      // we keep a cache which is cleared on each position call
	      if (typeof this._cache === 'undefined') {
	        this._cache = {};
	      }
	
	      if (typeof this._cache[k] === 'undefined') {
	        this._cache[k] = getter.call(this);
	      }
	
	      return this._cache[k];
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      var _this3 = this;
	
	      var pos = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	      if (!(this.options.addTargetClasses === false)) {
	        addClass(this.target, this.getClass('enabled'));
	      }
	      addClass(this.element, this.getClass('enabled'));
	      this.enabled = true;
	
	      this.scrollParents.forEach(function (parent) {
	        if (parent !== _this3.target.ownerDocument) {
	          parent.addEventListener('scroll', _this3.position);
	        }
	      });
	
	      if (pos) {
	        this.position();
	      }
	    }
	  }, {
	    key: 'disable',
	    value: function disable() {
	      var _this4 = this;
	
	      removeClass(this.target, this.getClass('enabled'));
	      removeClass(this.element, this.getClass('enabled'));
	      this.enabled = false;
	
	      if (typeof this.scrollParents !== 'undefined') {
	        this.scrollParents.forEach(function (parent) {
	          parent.removeEventListener('scroll', _this4.position);
	        });
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      var _this5 = this;
	
	      this.disable();
	
	      tethers.forEach(function (tether, i) {
	        if (tether === _this5) {
	          tethers.splice(i, 1);
	        }
	      });
	
	      // Remove any elements we were using for convenience from the DOM
	      if (tethers.length === 0) {
	        removeUtilElements();
	      }
	    }
	  }, {
	    key: 'updateAttachClasses',
	    value: function updateAttachClasses(elementAttach, targetAttach) {
	      var _this6 = this;
	
	      elementAttach = elementAttach || this.attachment;
	      targetAttach = targetAttach || this.targetAttachment;
	      var sides = ['left', 'top', 'bottom', 'right', 'middle', 'center'];
	
	      if (typeof this._addAttachClasses !== 'undefined' && this._addAttachClasses.length) {
	        // updateAttachClasses can be called more than once in a position call, so
	        // we need to clean up after ourselves such that when the last defer gets
	        // ran it doesn't add any extra classes from previous calls.
	        this._addAttachClasses.splice(0, this._addAttachClasses.length);
	      }
	
	      if (typeof this._addAttachClasses === 'undefined') {
	        this._addAttachClasses = [];
	      }
	      var add = this._addAttachClasses;
	
	      if (elementAttach.top) {
	        add.push(this.getClass('element-attached', elementAttach.top));
	      }
	      if (elementAttach.left) {
	        add.push(this.getClass('element-attached', elementAttach.left));
	      }
	      if (targetAttach.top) {
	        add.push(this.getClass('target-attached', targetAttach.top));
	      }
	      if (targetAttach.left) {
	        add.push(this.getClass('target-attached', targetAttach.top));
	      }
	
	      var all = [];
	      sides.forEach(function (side) {
	        all.push(_this6.getClass('element-attached', side));
	        all.push(_this6.getClass('target-attached', side));
	      });
	
	      defer(function () {
	        if (!(typeof _this6._addAttachClasses !== 'undefined')) {
	          return;
	        }
	
	        updateClasses(_this6.element, _this6._addAttachClasses, all);
	        if (!(_this6.options.addTargetClasses === false)) {
	          updateClasses(_this6.target, _this6._addAttachClasses, all);
	        }
	
	        delete _this6._addAttachClasses;
	      });
	    }
	  }, {
	    key: 'position',
	    value: function position() {
	      var _this7 = this;
	
	      var flushChanges = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	      // flushChanges commits the changes immediately, leave true unless you are positioning multiple
	      // tethers (in which case call Tether.Utils.flush yourself when you're done)
	
	      if (!this.enabled) {
	        return;
	      }
	
	      this.clearCache();
	
	      // Turn 'auto' attachments into the appropriate corner or edge
	      var targetAttachment = autoToFixedAttachment(this.targetAttachment, this.attachment);
	
	      this.updateAttachClasses(this.attachment, targetAttachment);
	
	      var elementPos = this.cache('element-bounds', function () {
	        return getBounds(_this7.element);
	      });
	
	      var width = elementPos.width;
	      var height = elementPos.height;
	
	      if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
	        var _lastSize = this.lastSize;
	
	        // We cache the height and width to make it possible to position elements that are
	        // getting hidden.
	        width = _lastSize.width;
	        height = _lastSize.height;
	      } else {
	        this.lastSize = { width: width, height: height };
	      }
	
	      var targetPos = this.cache('target-bounds', function () {
	        return _this7.getTargetBounds();
	      });
	      var targetSize = targetPos;
	
	      // Get an actual px offset from the attachment
	      var offset = offsetToPx(attachmentToOffset(this.attachment), { width: width, height: height });
	      var targetOffset = offsetToPx(attachmentToOffset(targetAttachment), targetSize);
	
	      var manualOffset = offsetToPx(this.offset, { width: width, height: height });
	      var manualTargetOffset = offsetToPx(this.targetOffset, targetSize);
	
	      // Add the manually provided offset
	      offset = addOffset(offset, manualOffset);
	      targetOffset = addOffset(targetOffset, manualTargetOffset);
	
	      // It's now our goal to make (element position + offset) == (target position + target offset)
	      var left = targetPos.left + targetOffset.left - offset.left;
	      var top = targetPos.top + targetOffset.top - offset.top;
	
	      for (var i = 0; i < TetherBase.modules.length; ++i) {
	        var _module2 = TetherBase.modules[i];
	        var ret = _module2.position.call(this, {
	          left: left,
	          top: top,
	          targetAttachment: targetAttachment,
	          targetPos: targetPos,
	          elementPos: elementPos,
	          offset: offset,
	          targetOffset: targetOffset,
	          manualOffset: manualOffset,
	          manualTargetOffset: manualTargetOffset,
	          scrollbarSize: scrollbarSize,
	          attachment: this.attachment
	        });
	
	        if (ret === false) {
	          return false;
	        } else if (typeof ret === 'undefined' || typeof ret !== 'object') {
	          continue;
	        } else {
	          top = ret.top;
	          left = ret.left;
	        }
	      }
	
	      // We describe the position three different ways to give the optimizer
	      // a chance to decide the best possible way to position the element
	      // with the fewest repaints.
	      var next = {
	        // It's position relative to the page (absolute positioning when
	        // the element is a child of the body)
	        page: {
	          top: top,
	          left: left
	        },
	
	        // It's position relative to the viewport (fixed positioning)
	        viewport: {
	          top: top - pageYOffset,
	          bottom: pageYOffset - top - height + innerHeight,
	          left: left - pageXOffset,
	          right: pageXOffset - left - width + innerWidth
	        }
	      };
	
	      var doc = this.target.ownerDocument;
	      var win = doc.defaultView;
	
	      var scrollbarSize = undefined;
	      if (win.innerHeight > doc.documentElement.clientHeight) {
	        scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
	        next.viewport.bottom -= scrollbarSize.height;
	      }
	
	      if (win.innerWidth > doc.documentElement.clientWidth) {
	        scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
	        next.viewport.right -= scrollbarSize.width;
	      }
	
	      if (['', 'static'].indexOf(doc.body.style.position) === -1 || ['', 'static'].indexOf(doc.body.parentElement.style.position) === -1) {
	        // Absolute positioning in the body will be relative to the page, not the 'initial containing block'
	        next.page.bottom = doc.body.scrollHeight - top - height;
	        next.page.right = doc.body.scrollWidth - left - width;
	      }
	
	      if (typeof this.options.optimizations !== 'undefined' && this.options.optimizations.moveElement !== false && !(typeof this.targetModifier !== 'undefined')) {
	        (function () {
	          var offsetParent = _this7.cache('target-offsetparent', function () {
	            return getOffsetParent(_this7.target);
	          });
	          var offsetPosition = _this7.cache('target-offsetparent-bounds', function () {
	            return getBounds(offsetParent);
	          });
	          var offsetParentStyle = getComputedStyle(offsetParent);
	          var offsetParentSize = offsetPosition;
	
	          var offsetBorder = {};
	          ['Top', 'Left', 'Bottom', 'Right'].forEach(function (side) {
	            offsetBorder[side.toLowerCase()] = parseFloat(offsetParentStyle['border' + side + 'Width']);
	          });
	
	          offsetPosition.right = doc.body.scrollWidth - offsetPosition.left - offsetParentSize.width + offsetBorder.right;
	          offsetPosition.bottom = doc.body.scrollHeight - offsetPosition.top - offsetParentSize.height + offsetBorder.bottom;
	
	          if (next.page.top >= offsetPosition.top + offsetBorder.top && next.page.bottom >= offsetPosition.bottom) {
	            if (next.page.left >= offsetPosition.left + offsetBorder.left && next.page.right >= offsetPosition.right) {
	              // We're within the visible part of the target's scroll parent
	              var scrollTop = offsetParent.scrollTop;
	              var scrollLeft = offsetParent.scrollLeft;
	
	              // It's position relative to the target's offset parent (absolute positioning when
	              // the element is moved to be a child of the target's offset parent).
	              next.offset = {
	                top: next.page.top - offsetPosition.top + scrollTop - offsetBorder.top,
	                left: next.page.left - offsetPosition.left + scrollLeft - offsetBorder.left
	              };
	            }
	          }
	        })();
	      }
	
	      // We could also travel up the DOM and try each containing context, rather than only
	      // looking at the body, but we're gonna get diminishing returns.
	
	      this.move(next);
	
	      this.history.unshift(next);
	
	      if (this.history.length > 3) {
	        this.history.pop();
	      }
	
	      if (flushChanges) {
	        flush();
	      }
	
	      return true;
	    }
	
	    // THE ISSUE
	  }, {
	    key: 'move',
	    value: function move(pos) {
	      var _this8 = this;
	
	      if (!(typeof this.element.parentNode !== 'undefined')) {
	        return;
	      }
	
	      var same = {};
	
	      for (var type in pos) {
	        same[type] = {};
	
	        for (var key in pos[type]) {
	          var found = false;
	
	          for (var i = 0; i < this.history.length; ++i) {
	            var point = this.history[i];
	            if (typeof point[type] !== 'undefined' && !within(point[type][key], pos[type][key])) {
	              found = true;
	              break;
	            }
	          }
	
	          if (!found) {
	            same[type][key] = true;
	          }
	        }
	      }
	
	      var css = { top: '', left: '', right: '', bottom: '' };
	
	      var transcribe = function transcribe(_same, _pos) {
	        var hasOptimizations = typeof _this8.options.optimizations !== 'undefined';
	        var gpu = hasOptimizations ? _this8.options.optimizations.gpu : null;
	        if (gpu !== false) {
	          var yPos = undefined,
	              xPos = undefined;
	          if (_same.top) {
	            css.top = 0;
	            yPos = _pos.top;
	          } else {
	            css.bottom = 0;
	            yPos = -_pos.bottom;
	          }
	
	          if (_same.left) {
	            css.left = 0;
	            xPos = _pos.left;
	          } else {
	            css.right = 0;
	            xPos = -_pos.right;
	          }
	
	          if (window.matchMedia) {
	            // HubSpot/tether#207
	            var retina = window.matchMedia('only screen and (min-resolution: 1.3dppx)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3)').matches;
	            if (!retina) {
	              xPos = Math.round(xPos);
	              yPos = Math.round(yPos);
	            }
	          }
	
	          css[transformKey] = 'translateX(' + xPos + 'px) translateY(' + yPos + 'px)';
	
	          if (transformKey !== 'msTransform') {
	            // The Z transform will keep this in the GPU (faster, and prevents artifacts),
	            // but IE9 doesn't support 3d transforms and will choke.
	            css[transformKey] += " translateZ(0)";
	          }
	        } else {
	          if (_same.top) {
	            css.top = _pos.top + 'px';
	          } else {
	            css.bottom = _pos.bottom + 'px';
	          }
	
	          if (_same.left) {
	            css.left = _pos.left + 'px';
	          } else {
	            css.right = _pos.right + 'px';
	          }
	        }
	      };
	
	      var moved = false;
	      if ((same.page.top || same.page.bottom) && (same.page.left || same.page.right)) {
	        css.position = 'absolute';
	        transcribe(same.page, pos.page);
	      } else if ((same.viewport.top || same.viewport.bottom) && (same.viewport.left || same.viewport.right)) {
	        css.position = 'fixed';
	        transcribe(same.viewport, pos.viewport);
	      } else if (typeof same.offset !== 'undefined' && same.offset.top && same.offset.left) {
	        (function () {
	          css.position = 'absolute';
	          var offsetParent = _this8.cache('target-offsetparent', function () {
	            return getOffsetParent(_this8.target);
	          });
	
	          if (getOffsetParent(_this8.element) !== offsetParent) {
	            defer(function () {
	              _this8.element.parentNode.removeChild(_this8.element);
	              offsetParent.appendChild(_this8.element);
	            });
	          }
	
	          transcribe(same.offset, pos.offset);
	          moved = true;
	        })();
	      } else {
	        css.position = 'absolute';
	        transcribe({ top: true, left: true }, pos.page);
	      }
	
	      if (!moved) {
	        if (this.options.bodyElement) {
	          this.options.bodyElement.appendChild(this.element);
	        } else {
	          var offsetParentIsBody = true;
	          var currentNode = this.element.parentNode;
	          while (currentNode && currentNode.nodeType === 1 && currentNode.tagName !== 'BODY') {
	            if (getComputedStyle(currentNode).position !== 'static') {
	              offsetParentIsBody = false;
	              break;
	            }
	
	            currentNode = currentNode.parentNode;
	          }
	
	          if (!offsetParentIsBody) {
	            this.element.parentNode.removeChild(this.element);
	            this.element.ownerDocument.body.appendChild(this.element);
	          }
	        }
	      }
	
	      // Any css change will trigger a repaint, so let's avoid one if nothing changed
	      var writeCSS = {};
	      var write = false;
	      for (var key in css) {
	        var val = css[key];
	        var elVal = this.element.style[key];
	
	        if (elVal !== val) {
	          write = true;
	          writeCSS[key] = val;
	        }
	      }
	
	      if (write) {
	        defer(function () {
	          extend(_this8.element.style, writeCSS);
	          _this8.trigger('repositioned');
	        });
	      }
	    }
	  }]);
	
	  return TetherClass;
	})(Evented);
	
	TetherClass.modules = [];
	
	TetherBase.position = position;
	
	var Tether = extend(TetherClass, TetherBase);
	/* globals TetherBase */
	
	'use strict';
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _TetherBase$Utils = TetherBase.Utils;
	var getBounds = _TetherBase$Utils.getBounds;
	var extend = _TetherBase$Utils.extend;
	var updateClasses = _TetherBase$Utils.updateClasses;
	var defer = _TetherBase$Utils.defer;
	
	var BOUNDS_FORMAT = ['left', 'top', 'right', 'bottom'];
	
	function getBoundingRect(tether, to) {
	  if (to === 'scrollParent') {
	    to = tether.scrollParents[0];
	  } else if (to === 'window') {
	    to = [pageXOffset, pageYOffset, innerWidth + pageXOffset, innerHeight + pageYOffset];
	  }
	
	  if (to === document) {
	    to = to.documentElement;
	  }
	
	  if (typeof to.nodeType !== 'undefined') {
	    (function () {
	      var node = to;
	      var size = getBounds(to);
	      var pos = size;
	      var style = getComputedStyle(to);
	
	      to = [pos.left, pos.top, size.width + pos.left, size.height + pos.top];
	
	      // Account any parent Frames scroll offset
	      if (node.ownerDocument !== document) {
	        var win = node.ownerDocument.defaultView;
	        to[0] += win.pageXOffset;
	        to[1] += win.pageYOffset;
	        to[2] += win.pageXOffset;
	        to[3] += win.pageYOffset;
	      }
	
	      BOUNDS_FORMAT.forEach(function (side, i) {
	        side = side[0].toUpperCase() + side.substr(1);
	        if (side === 'Top' || side === 'Left') {
	          to[i] += parseFloat(style['border' + side + 'Width']);
	        } else {
	          to[i] -= parseFloat(style['border' + side + 'Width']);
	        }
	      });
	    })();
	  }
	
	  return to;
	}
	
	TetherBase.modules.push({
	  position: function position(_ref) {
	    var _this = this;
	
	    var top = _ref.top;
	    var left = _ref.left;
	    var targetAttachment = _ref.targetAttachment;
	
	    if (!this.options.constraints) {
	      return true;
	    }
	
	    var _cache = this.cache('element-bounds', function () {
	      return getBounds(_this.element);
	    });
	
	    var height = _cache.height;
	    var width = _cache.width;
	
	    if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
	      var _lastSize = this.lastSize;
	
	      // Handle the item getting hidden as a result of our positioning without glitching
	      // the classes in and out
	      width = _lastSize.width;
	      height = _lastSize.height;
	    }
	
	    var targetSize = this.cache('target-bounds', function () {
	      return _this.getTargetBounds();
	    });
	
	    var targetHeight = targetSize.height;
	    var targetWidth = targetSize.width;
	
	    var allClasses = ['pinned', 'out-of-bounds'];
	
	    this.options.constraints.forEach(function (constraint) {
	      var outOfBoundsClass = constraint.outOfBoundsClass;
	      var pinnedClass = constraint.pinnedClass;
	
	      if (outOfBoundsClass) {
	        allClasses.push(outOfBoundsClass);
	      }
	      if (pinnedClass) {
	        allClasses.push(pinnedClass);
	      }
	    });
	
	    allClasses.forEach(function (cls) {
	      allClasses.push(_this.getClass(cls));
	
	      ['left', 'top', 'right', 'bottom'].forEach(function (side) {
	        allClasses.push(_this.getClass(cls, side));
	      });
	    });
	
	    var addClasses = [];
	
	    var tAttachment = extend({}, targetAttachment);
	    var eAttachment = extend({}, this.attachment);
	
	    this.options.constraints.forEach(function (constraint) {
	      var to = constraint.to;
	      var attachment = constraint.attachment;
	      var pin = constraint.pin;
	
	      if (typeof attachment === 'undefined') {
	        attachment = '';
	      }
	
	      var changeAttachX = undefined,
	          changeAttachY = undefined;
	      if (attachment.indexOf(' ') >= 0) {
	        var _attachment$split = attachment.split(' ');
	
	        var _attachment$split2 = _slicedToArray(_attachment$split, 2);
	
	        changeAttachY = _attachment$split2[0];
	        changeAttachX = _attachment$split2[1];
	      } else {
	        changeAttachX = changeAttachY = attachment;
	      }
	
	      var bounds = getBoundingRect(_this, to);
	
	      if (changeAttachY === 'target' || changeAttachY === 'both') {
	        if (top < bounds[1] && tAttachment.top === 'top') {
	          top += targetHeight;
	          tAttachment.top = 'bottom';
	        }
	
	        if (top + height > bounds[3] && tAttachment.top === 'bottom') {
	          top -= targetHeight;
	          tAttachment.top = 'top';
	        }
	      }
	
	      if (changeAttachY === 'together') {
	        if (tAttachment.top === 'top') {
	          if (eAttachment.top === 'bottom' && top < bounds[1]) {
	            top += targetHeight;
	            tAttachment.top = 'bottom';
	
	            top += height;
	            eAttachment.top = 'top';
	          } else if (eAttachment.top === 'top' && top + height > bounds[3] && top - (height - targetHeight) >= bounds[1]) {
	            top -= height - targetHeight;
	            tAttachment.top = 'bottom';
	
	            eAttachment.top = 'bottom';
	          }
	        }
	
	        if (tAttachment.top === 'bottom') {
	          if (eAttachment.top === 'top' && top + height > bounds[3]) {
	            top -= targetHeight;
	            tAttachment.top = 'top';
	
	            top -= height;
	            eAttachment.top = 'bottom';
	          } else if (eAttachment.top === 'bottom' && top < bounds[1] && top + (height * 2 - targetHeight) <= bounds[3]) {
	            top += height - targetHeight;
	            tAttachment.top = 'top';
	
	            eAttachment.top = 'top';
	          }
	        }
	
	        if (tAttachment.top === 'middle') {
	          if (top + height > bounds[3] && eAttachment.top === 'top') {
	            top -= height;
	            eAttachment.top = 'bottom';
	          } else if (top < bounds[1] && eAttachment.top === 'bottom') {
	            top += height;
	            eAttachment.top = 'top';
	          }
	        }
	      }
	
	      if (changeAttachX === 'target' || changeAttachX === 'both') {
	        if (left < bounds[0] && tAttachment.left === 'left') {
	          left += targetWidth;
	          tAttachment.left = 'right';
	        }
	
	        if (left + width > bounds[2] && tAttachment.left === 'right') {
	          left -= targetWidth;
	          tAttachment.left = 'left';
	        }
	      }
	
	      if (changeAttachX === 'together') {
	        if (left < bounds[0] && tAttachment.left === 'left') {
	          if (eAttachment.left === 'right') {
	            left += targetWidth;
	            tAttachment.left = 'right';
	
	            left += width;
	            eAttachment.left = 'left';
	          } else if (eAttachment.left === 'left') {
	            left += targetWidth;
	            tAttachment.left = 'right';
	
	            left -= width;
	            eAttachment.left = 'right';
	          }
	        } else if (left + width > bounds[2] && tAttachment.left === 'right') {
	          if (eAttachment.left === 'left') {
	            left -= targetWidth;
	            tAttachment.left = 'left';
	
	            left -= width;
	            eAttachment.left = 'right';
	          } else if (eAttachment.left === 'right') {
	            left -= targetWidth;
	            tAttachment.left = 'left';
	
	            left += width;
	            eAttachment.left = 'left';
	          }
	        } else if (tAttachment.left === 'center') {
	          if (left + width > bounds[2] && eAttachment.left === 'left') {
	            left -= width;
	            eAttachment.left = 'right';
	          } else if (left < bounds[0] && eAttachment.left === 'right') {
	            left += width;
	            eAttachment.left = 'left';
	          }
	        }
	      }
	
	      if (changeAttachY === 'element' || changeAttachY === 'both') {
	        if (top < bounds[1] && eAttachment.top === 'bottom') {
	          top += height;
	          eAttachment.top = 'top';
	        }
	
	        if (top + height > bounds[3] && eAttachment.top === 'top') {
	          top -= height;
	          eAttachment.top = 'bottom';
	        }
	      }
	
	      if (changeAttachX === 'element' || changeAttachX === 'both') {
	        if (left < bounds[0]) {
	          if (eAttachment.left === 'right') {
	            left += width;
	            eAttachment.left = 'left';
	          } else if (eAttachment.left === 'center') {
	            left += width / 2;
	            eAttachment.left = 'left';
	          }
	        }
	
	        if (left + width > bounds[2]) {
	          if (eAttachment.left === 'left') {
	            left -= width;
	            eAttachment.left = 'right';
	          } else if (eAttachment.left === 'center') {
	            left -= width / 2;
	            eAttachment.left = 'right';
	          }
	        }
	      }
	
	      if (typeof pin === 'string') {
	        pin = pin.split(',').map(function (p) {
	          return p.trim();
	        });
	      } else if (pin === true) {
	        pin = ['top', 'left', 'right', 'bottom'];
	      }
	
	      pin = pin || [];
	
	      var pinned = [];
	      var oob = [];
	
	      if (top < bounds[1]) {
	        if (pin.indexOf('top') >= 0) {
	          top = bounds[1];
	          pinned.push('top');
	        } else {
	          oob.push('top');
	        }
	      }
	
	      if (top + height > bounds[3]) {
	        if (pin.indexOf('bottom') >= 0) {
	          top = bounds[3] - height;
	          pinned.push('bottom');
	        } else {
	          oob.push('bottom');
	        }
	      }
	
	      if (left < bounds[0]) {
	        if (pin.indexOf('left') >= 0) {
	          left = bounds[0];
	          pinned.push('left');
	        } else {
	          oob.push('left');
	        }
	      }
	
	      if (left + width > bounds[2]) {
	        if (pin.indexOf('right') >= 0) {
	          left = bounds[2] - width;
	          pinned.push('right');
	        } else {
	          oob.push('right');
	        }
	      }
	
	      if (pinned.length) {
	        var pinnedClass = undefined;
	        if (typeof _this.options.pinnedClass !== 'undefined') {
	          pinnedClass = _this.options.pinnedClass;
	        } else {
	          pinnedClass = _this.getClass('pinned');
	        }
	
	        addClasses.push(pinnedClass);
	        pinned.forEach(function (side) {
	          addClasses.push(_this.getClass('pinned-' + side));
	        });
	      }
	
	      if (oob.length) {
	        var oobClass = undefined;
	        if (typeof _this.options.outOfBoundsClass !== 'undefined') {
	          oobClass = _this.options.outOfBoundsClass;
	        } else {
	          oobClass = _this.getClass('out-of-bounds');
	        }
	
	        addClasses.push(oobClass);
	        oob.forEach(function (side) {
	          addClasses.push(_this.getClass('out-of-bounds', side));
	        });
	      }
	
	      if (pinned.indexOf('left') >= 0 || pinned.indexOf('right') >= 0) {
	        eAttachment.left = tAttachment.left = false;
	      }
	      if (pinned.indexOf('top') >= 0 || pinned.indexOf('bottom') >= 0) {
	        eAttachment.top = tAttachment.top = false;
	      }
	
	      if (tAttachment.top !== targetAttachment.top || tAttachment.left !== targetAttachment.left || eAttachment.top !== _this.attachment.top || eAttachment.left !== _this.attachment.left) {
	        _this.updateAttachClasses(eAttachment, tAttachment);
	        _this.trigger('update', {
	          attachment: eAttachment,
	          targetAttachment: tAttachment
	        });
	      }
	    });
	
	    defer(function () {
	      if (!(_this.options.addTargetClasses === false)) {
	        updateClasses(_this.target, addClasses, allClasses);
	      }
	      updateClasses(_this.element, addClasses, allClasses);
	    });
	
	    return { top: top, left: left };
	  }
	});
	/* globals TetherBase */
	
	'use strict';
	
	var _TetherBase$Utils = TetherBase.Utils;
	var getBounds = _TetherBase$Utils.getBounds;
	var updateClasses = _TetherBase$Utils.updateClasses;
	var defer = _TetherBase$Utils.defer;
	
	TetherBase.modules.push({
	  position: function position(_ref) {
	    var _this = this;
	
	    var top = _ref.top;
	    var left = _ref.left;
	
	    var _cache = this.cache('element-bounds', function () {
	      return getBounds(_this.element);
	    });
	
	    var height = _cache.height;
	    var width = _cache.width;
	
	    var targetPos = this.getTargetBounds();
	
	    var bottom = top + height;
	    var right = left + width;
	
	    var abutted = [];
	    if (top <= targetPos.bottom && bottom >= targetPos.top) {
	      ['left', 'right'].forEach(function (side) {
	        var targetPosSide = targetPos[side];
	        if (targetPosSide === left || targetPosSide === right) {
	          abutted.push(side);
	        }
	      });
	    }
	
	    if (left <= targetPos.right && right >= targetPos.left) {
	      ['top', 'bottom'].forEach(function (side) {
	        var targetPosSide = targetPos[side];
	        if (targetPosSide === top || targetPosSide === bottom) {
	          abutted.push(side);
	        }
	      });
	    }
	
	    var allClasses = [];
	    var addClasses = [];
	
	    var sides = ['left', 'top', 'right', 'bottom'];
	    allClasses.push(this.getClass('abutted'));
	    sides.forEach(function (side) {
	      allClasses.push(_this.getClass('abutted', side));
	    });
	
	    if (abutted.length) {
	      addClasses.push(this.getClass('abutted'));
	    }
	
	    abutted.forEach(function (side) {
	      addClasses.push(_this.getClass('abutted', side));
	    });
	
	    defer(function () {
	      if (!(_this.options.addTargetClasses === false)) {
	        updateClasses(_this.target, addClasses, allClasses);
	      }
	      updateClasses(_this.element, addClasses, allClasses);
	    });
	
	    return true;
	  }
	});
	/* globals TetherBase */
	
	'use strict';
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	TetherBase.modules.push({
	  position: function position(_ref) {
	    var top = _ref.top;
	    var left = _ref.left;
	
	    if (!this.options.shift) {
	      return;
	    }
	
	    var shift = this.options.shift;
	    if (typeof this.options.shift === 'function') {
	      shift = this.options.shift.call(this, { top: top, left: left });
	    }
	
	    var shiftTop = undefined,
	        shiftLeft = undefined;
	    if (typeof shift === 'string') {
	      shift = shift.split(' ');
	      shift[1] = shift[1] || shift[0];
	
	      var _shift = shift;
	
	      var _shift2 = _slicedToArray(_shift, 2);
	
	      shiftTop = _shift2[0];
	      shiftLeft = _shift2[1];
	
	      shiftTop = parseFloat(shiftTop, 10);
	      shiftLeft = parseFloat(shiftLeft, 10);
	    } else {
	      shiftTop = shift.top;
	      shiftLeft = shift.left;
	    }
	
	    top += shiftTop;
	    left += shiftLeft;
	
	    return { top: top, left: left };
	  }
	});
	return Tether;
	
	}));


/***/ }),

/***/ 1144:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FullScreen() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "12", height: "12", viewBox: "0 0 12 12", className: "display-block" },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        {
	          fill: "currentColor",
	          fillRule: "nonzero",
	          transform: "translate(-1249 -1008)"
	        },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(1235 994)" },
	          _react2.default.createElement("path", { d: "M25.09 21a.91.91 0 01.91.91v2.726C26 25.39 25.39 26 24.636 26H21.91a.91.91 0 010-1.818h2.046a.227.227 0 00.227-.227v-2.046A.91.91 0 0125.09 21zm-10.18 0a.91.91 0 01.908.91v2.045c0 .125.102.227.227.227h2.046a.91.91 0 110 1.818h-2.727C14.61 26 14 25.39 14 24.636V21.91a.91.91 0 01.91-.909zm3.18-7a.91.91 0 010 1.818h-2.045a.227.227 0 00-.227.227v2.046a.91.91 0 11-1.818 0v-2.727c0-.753.61-1.364 1.364-1.364h2.727zm6.546 0c.753 0 1.364.61 1.364 1.364v2.727a.91.91 0 01-1.818 0v-2.046a.227.227 0 00-.227-.227h-2.046a.91.91 0 110-1.818h2.727z" })
	        )
	      )
	    )
	  );
	}
	
	exports.default = FullScreen;
	module.exports = exports["default"];

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AnchorIcon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "21",
	      height: "21",
	      viewBox: "0 0 21 21"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { fill: "#FFF", fillRule: "nonzero", transform: "translate(-961 -1344)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(926 1175)" },
	          _react2.default.createElement("path", { d: "M56 182.883l-.583-4.083c-.117-.7-.7-1.167-1.284-1.167-.35 0-.7.117-.933.467l-2.8 2.917-.233.233c-.467.583-.35 1.517.35 1.983l.35.234h.116C50.4 184.75 49 185.683 47.6 186.15v-7c1.867-.817 3.267-2.683 3.267-4.9-.117-2.917-2.45-5.25-5.367-5.25a5.228 5.228 0 00-5.25 5.25c0 2.217 1.4 4.083 3.267 4.9v7.117c-1.4-.467-2.684-1.4-3.384-2.684h.117c.117 0 .233-.116.35-.233.35-.233.467-.583.583-.933 0-.35 0-.817-.233-1.05-.117-.117-.117-.234-.233-.234l-2.8-3.033c-.234-.35-.584-.467-.934-.467-.7 0-1.166.467-1.4 1.167L35 182.883v.35c0 .817.583 1.4 1.4 1.4.117 0 .35 0 .467-.116h.116C38.267 187.783 41.767 190 45.5 190c3.733 0 7.233-2.217 8.517-5.483h.116c.117 0 .234.116.467.116.817 0 1.4-.7 1.4-1.4v-.35zm-10.5-11.316a2.59 2.59 0 012.567 2.566A2.59 2.59 0 0145.5 176.7a2.59 2.59 0 01-2.567-2.567c-.116-1.283 1.167-2.566 2.567-2.566z" })
	        )
	      )
	    )
	  );
	}
	
	exports.default = AnchorIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AnchorPreview() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "108",
	      height: "108",
	      viewBox: "0 0 108 108"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { transform: "translate(-1050 -1228)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(926 1175)" },
	          _react2.default.createElement(
	            "g",
	            { transform: "translate(124 53)" },
	            _react2.default.createElement("path", { fill: "#FFF", d: "M0 0H108V108H0z" }),
	            _react2.default.createElement("path", {
	              fill: "#EFEFEF",
	              d: "M93 98a4 4 0 014 4v6H10v-6a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V73a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V44a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V15a4 4 0 014-4h79z"
	            }),
	            _react2.default.createElement("rect", {
	              width: "30",
	              height: "30",
	              x: "69",
	              y: "71",
	              fill: "currentColor",
	              rx: "4"
	            }),
	            _react2.default.createElement("path", {
	              fill: "#C5C5C5",
	              fillRule: "nonzero",
	              d: "M51.39 75.02a2.652 2.652 0 002.13-2.598V52.539h12.5c.625 0 1.25-.625 1.25-1.25 0-.45-.176-.8-.508-1.016l-.02-.02L52.758 36.25c-.899-.996-2.5-.996-3.516 0l-14.12 14.121c-.411.41-.49.86-.255 1.387.137.469.625.742 1.153.742h12.5v20c0 1.523 1.386 2.773 2.87 2.52z"
	            })
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = AnchorPreview;
	module.exports = exports["default"];

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ContainersIcon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "18",
	      height: "18",
	      viewBox: "0 0 18 18"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { fill: "#FFF", fillRule: "nonzero", transform: "translate(-172 -1346)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(136 1175)" },
	          _react2.default.createElement("path", { d: "M52.615 171c.765 0 1.385.62 1.385 1.385v15.23c0 .765-.62 1.385-1.385 1.385h-15.23c-.765 0-1.385-.62-1.385-1.385v-15.23c0-.765.62-1.385 1.385-1.385h15.23zm-4.153 13.846h-9.693a1.385 1.385 0 00-.161 2.76l.161.01h9.693a1.385 1.385 0 00.161-2.76l-.161-.01zm2.769-12.461c-.71 0-1.296.534-1.376 1.223l-.009.161v4.154a1.385 1.385 0 002.76.162l.01-.162v-4.154c0-.764-.62-1.384-1.385-1.384z" })
	        )
	      )
	    )
	  );
	}
	
	exports.default = ContainersIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ContainersPreview() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "108",
	      height: "108",
	      viewBox: "0 0 108 108"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { transform: "translate(-260 -1228)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(136 1175)" },
	          _react2.default.createElement(
	            "g",
	            { transform: "translate(124 53)" },
	            _react2.default.createElement("path", { fill: "#FFF", d: "M0 0H108V108H0z" }),
	            _react2.default.createElement("path", {
	              fill: "#EFEFEF",
	              d: "M93 98a4 4 0 014 4v6H10v-6a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V73a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V44a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V15a4 4 0 014-4h79z"
	            }),
	            _react2.default.createElement("rect", {
	              width: "31",
	              height: "31",
	              x: "10",
	              y: "11",
	              fill: "currentColor",
	              rx: "4"
	            })
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = ContainersPreview;
	module.exports = exports["default"];

/***/ }),

/***/ 1180:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DiagonalArrow() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "6",
	      height: "6",
	      viewBox: "0 0 6 6"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { fill: "#1FB6FF", fillRule: "nonzero", transform: "translate(-146 -9)" },
	        _react2.default.createElement("path", { d: "M151.503 9c.275 0 .497.222.497.497v3.972a.497.497 0 01-.993 0l-.001-2.64-3.975 4.021a.5.5 0 01-.707.004l-.178-.18a.5.5 0 010-.703l3.932-3.978h-2.548a.497.497 0 010-.993h3.973z" })
	      )
	    )
	  );
	}
	
	exports.default = DiagonalArrow;
	module.exports = exports["default"];

/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EmbedIcon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "20",
	      height: "20",
	      viewBox: "0 0 20 20"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { fill: "#FFF", fillRule: "nonzero", transform: "translate(-566 -1345)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(531 1175)" },
	          _react2.default.createElement("path", { d: "M48.125 170c-1.875 0-3.625.75-5.25 2.375-1.5 1.625-2.25 3.25-2.375 5.125 0 1.875.625 3.5 2.125 5 .375.375.75.625 1.125.875.875-1.125 1.25-2.5 1-4.125l.25.25.5.75c.5.875.625 1.75.5 2.5-.125.875-.625 1.75-1.375 2.375-1 .875-1.875 1.375-2.875 1.375-.875 0-1.625-.375-2.375-1-.625-.625-1-1.375-1-2.125s.125-1.5.75-2.25c-.5-1.375-.75-2.75-.625-4.125-.5.375-.75.625-1.125.875C35.875 179.5 35 181.125 35 183s.625 3.5 2.125 5c1.375 1.25 2.875 2 4.75 2 .75 0 1.5-.125 2.125-.375.75-.25 1.375-.625 2.125-1.125 1.125-.875 2-1.875 2.625-3 .25-.375.375-.75.375-.875.5-1.25.5-2.5.25-3.75s-1-2.375-1.875-3.375c-.875-.875-1.75-1.375-2.875-1.75.125-.25.375-.625.75-1 1-.875 1.875-1.375 2.875-1.375.875 0 1.625.375 2.375 1 .75.75 1 1.5 1 2.375 0 .625-.25 1.375-.75 2.125.5 1.125.75 2.25.75 3.375v.75c.375-.25.75-.5 1-.875C54.25 180.5 55 178.75 55 176.875c0-1.75-.75-3.375-2.125-4.75S50 170 48.125 170z" })
	        )
	      )
	    )
	  );
	}
	
	exports.default = EmbedIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EmbedMultimediaIcon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "15",
	      height: "18",
	      viewBox: "0 0 15 18"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { fill: "#FFF", transform: "translate(-964 -2145)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(926 1975)" },
	          _react2.default.createElement("path", { d: "M39.66 170a1.293 1.293 0 00-.707.203c-.34.208-.57.566-.629.97l-.048.623-.08.862-.035.469-.03.541-.025.614-.022.688-.009.37a92.755 92.755 0 00-.075 3.654c0 .877.014 1.784.042 2.72l.048 1.318.06 1.306.045.782.06.823.061.687.005.043c.007.469.252.898.643 1.124.213.136.458.206.707.203.163-.014.322-.055.472-.124a49.017 49.017 0 0012.384-7.757c.317-.276.492-.693.471-1.125a1.284 1.284 0 00-.471-1.056l-.056-.057-.156-.145-.342-.297-.256-.212-.426-.338-.989-.76-.239-.181a55.68 55.68 0 00-2.625-1.867c-.921-.622-2.039-1.3-3.353-2.035a39.82 39.82 0 00-3.942-1.933 1.424 1.424 0 00-.482-.113z" })
	        )
	      )
	    )
	  );
	}
	
	exports.default = EmbedMultimediaIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EmbedPreview() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "108",
	      height: "108",
	      viewBox: "0 0 108 108"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { transform: "translate(-668 -1228)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(531 1175)" },
	          _react2.default.createElement(
	            "g",
	            { transform: "translate(137 53)" },
	            _react2.default.createElement("path", { fill: "#FFF", d: "M0 0H108V108H0z" }),
	            _react2.default.createElement("path", {
	              fill: "#EFEFEF",
	              d: "M93 99a4 4 0 014 4v5H10v-5a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V74a4 4 0 014-4h79z"
	            }),
	            _react2.default.createElement("path", {
	              fill: "currentColor",
	              d: "M93 11a4 4 0 014 4v41a4 4 0 01-4 4H14a4 4 0 01-4-4V15a4 4 0 014-4h79zM47.55 27a1.251 1.251 0 00-.66.18 1.21 1.21 0 00-.587.864l-.045.554-.076.766-.032.417-.027.482-.024.546-.02.611c-.004.107-.006.217-.009.33A78.62 78.62 0 0046 35c0 .78.013 1.586.04 2.419l.044 1.173.056 1.16.042.697.057.731.056.612.005.038c.006.417.235.799.6 1 .199.12.428.183.66.18.152-.012.3-.05.44-.11A46.15 46.15 0 0059.56 36a1.22 1.22 0 00.44-1 1.12 1.12 0 00-.44-.94l-.052-.05-.146-.13-.319-.263-.24-.19-.397-.3-.922-.675-.224-.162a52.033 52.033 0 00-2.45-1.66 44.688 44.688 0 00-3.13-1.81A37.967 37.967 0 0048 27.1a1.384 1.384 0 00-.45-.1z"
	            })
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = EmbedPreview;
	module.exports = exports["default"];

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EmbedPreview() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "108",
	      height: "108",
	      viewBox: "0 0 108 108"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { transform: "translate(-668 -1228)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(531 1175)" },
	          _react2.default.createElement(
	            "g",
	            { transform: "translate(137 53)" },
	            _react2.default.createElement("path", { fill: "#FFF", d: "M0 0H108V108H0z" }),
	            _react2.default.createElement("path", {
	              fill: "#EFEFEF",
	              d: "M93 99a4 4 0 014 4v5H10v-5a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V74a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V45a4 4 0 014-4h79z"
	            }),
	            _react2.default.createElement("path", {
	              fill: "currentColor",
	              d: "M48 13a4 4 0 014 4v11a4 4 0 01-4 4H14a4 4 0 01-4-4V17a4 4 0 014-4h34zm-15.438 4c-.937 0-1.812.375-2.624 1.188-.75.812-1.125 1.625-1.188 2.562 0 .938.313 1.75 1.063 2.5.187.188.375.313.562.438.438-.563.625-1.25.5-2.063l.125.125.25.375c.25.438.313.875.25 1.25a1.945 1.945 0 01-.688 1.188c-.5.437-.937.687-1.437.687-.438 0-.813-.188-1.188-.5-.312-.313-.5-.688-.5-1.063s.063-.75.375-1.125c-.25-.687-.375-1.375-.312-2.062-.25.188-.375.313-.563.438C26.438 21.75 26 22.563 26 23.5c0 .938.313 1.75 1.063 2.5.687.625 1.437 1 2.375 1 .375 0 .75-.063 1.062-.188.375-.125.688-.312 1.063-.562.562-.438 1-.938 1.312-1.5.125-.188.188-.375.188-.438.25-.625.25-1.25.124-1.875-.124-.625-.5-1.187-.937-1.687a3.441 3.441 0 00-1.438-.875c.063-.125.188-.313.375-.5.5-.438.938-.688 1.438-.688.438 0 .813.188 1.188.5.374.375.5.75.5 1.188 0 .313-.126.688-.376 1.063.25.562.376 1.125.376 1.687v.375c.187-.125.374-.25.5-.438.812-.812 1.187-1.687 1.187-2.625 0-.875-.375-1.687-1.063-2.375C34.25 17.375 33.5 17 32.563 17z"
	            })
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = EmbedPreview;
	module.exports = exports["default"];

/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FixedHeaderFooterIcon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "25",
	      height: "20",
	      viewBox: "0 0 25 20"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { fill: "#FFF", fillRule: "nonzero", transform: "translate(-959 -1745)" },
	        _react2.default.createElement("path", { d: "M984 1763a2 2 0 01-2 2h-21a2 2 0 01-2-2v-16a2 2 0 012-2h21a2 2 0 012 2v16zm-3-12h-19v11h19v-11z" })
	      )
	    )
	  );
	}
	
	exports.default = FixedHeaderFooterIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FixedHeaderFooterPreview() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "108",
	      height: "108",
	      viewBox: "0 0 108 108"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement("path", { fill: "#FFF", d: "M0 0H108V108H0z" }),
	      _react2.default.createElement("path", {
	        fill: "#EFEFEF",
	        d: "M93 99a4 4 0 014 4v6H10v-6a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V74a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V45a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V16a4 4 0 014-4h79z"
	      }),
	      _react2.default.createElement("path", { fill: "currentColor", d: "M0 0H108V22H0z" })
	    )
	  );
	}
	
	exports.default = FixedHeaderFooterPreview;
	module.exports = exports["default"];

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function GifIcon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "28",
	      height: "28",
	      viewBox: "0 0 28 28"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { fill: "#FFF", fillRule: "nonzero", transform: "translate(-167 -2541)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(136 2375)" },
	          _react2.default.createElement(
	            "g",
	            { transform: "translate(31 166)" },
	            _react2.default.createElement("path", { d: "M12.25 20.708a.292.292 0 00-.292-.291H9.333A2.333 2.333 0 017 18.083v-1.75c0-.322.261-.583.583-.583h4.375c.161 0 .292-.13.292-.292v-1.166a.292.292 0 00-.292-.292H7.583A.583.583 0 017 13.417V9.333c0-.322.261-.583.583-.583h8.167c.322 0 .583.261.583.583v2.625c0 .161.13.292.292.292h2.917c.16 0 .291-.13.291-.292V4.667A4.667 4.667 0 0015.167 0h-14a1.167 1.167 0 100 2.333A2.333 2.333 0 013.5 4.667v13.416a4.667 4.667 0 004.667 4.667h3.791c.161 0 .292-.13.292-.292v-1.75zm4.083-14.291A.583.583 0 0115.75 7H7.583A.583.583 0 017 6.417v-3.5c0-.322.261-.584.583-.584H14a2.333 2.333 0 012.333 2.334v1.75z" }),
	            _react2.default.createElement("path", { d: "M28 15.75A1.75 1.75 0 0026.25 14h-10.5A1.75 1.75 0 0014 15.75v10.5c0 .966.784 1.75 1.75 1.75h10.5A1.75 1.75 0 0028 26.25v-10.5zm-4.625 6.183l-3.634 2.124a1.099 1.099 0 01-1.658-.934v-4.246a1.1 1.1 0 011.66-.934l3.634 2.124a1.078 1.078 0 01-.002 1.866z" })
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = GifIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function GifIcon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "108",
	      height: "108",
	      viewBox: "0 0 108 108"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement("path", { fill: "#FFF", d: "M0 0H108V108H0z" }),
	      _react2.default.createElement("path", {
	        fill: "#FFF",
	        fillRule: "nonzero",
	        d: "M80.19 65.983a1.333 1.333 0 001.048-1.313V54.615h6.147c.308 0 .615-.316.615-.632 0-.227-.086-.405-.25-.514l-.01-.01-6.877-7.081c-.442-.504-1.23-.504-1.729 0l-6.945 7.14c-.202.208-.24.435-.125.702.068.237.308.375.567.375h6.148V64.71c0 .77.682 1.403 1.412 1.274z",
	        transform: "rotate(-90 80 56)"
	      }),
	      _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M93 11a4 4 0 014 4v78a4 4 0 01-4 4H15a4 4 0 01-4-4V15a4 4 0 014-4h78zM48.55 46a1.251 1.251 0 00-.66.18 1.21 1.21 0 00-.587.864l-.045.554-.076.766-.032.417-.027.482-.024.546-.02.611c-.004.108-.006.217-.009.33A78.62 78.62 0 0047 54c0 .78.013 1.586.04 2.419l.044 1.173.056 1.16.042.697.057.731.056.612.005.038c.006.417.235.799.6 1 .199.12.428.183.66.18.152-.012.3-.049.44-.11A46.15 46.15 0 0060.56 55a1.22 1.22 0 00.44-1 1.12 1.12 0 00-.44-.94l-.052-.05-.146-.13-.319-.263-.24-.19-.397-.3-.922-.675-.224-.162a52.033 52.033 0 00-2.45-1.66 44.688 44.688 0 00-3.13-1.81A37.967 37.967 0 0049 46.1a1.384 1.384 0 00-.45-.1z"
	      })
	    )
	  );
	}
	
	exports.default = GifIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LastVisitedIcon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "21",
	      height: "21",
	      viewBox: "0 0 21 21"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { fill: "#FFF", fillRule: "nonzero", transform: "translate(-566 -1744)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(531 1575)" },
	          _react2.default.createElement(
	            "g",
	            { transform: "translate(35 169)" },
	            _react2.default.createElement("path", { d: "M19.425 7.458c-.263-.131-1.313-.393-2.888-.785-1.575-.393-1.575-.393-3.28-.654V1.177c0-.393-.132-.653-.395-.785C12.6.131 12.337 0 12.075 0s-.525.13-.788.261C9.581 1.308 7.612 2.617 5.775 4.318c-1.838 1.57-3.15 2.747-3.938 3.663a27.441 27.441 0 01-1.575 1.7c-.13.263-.262.524-.262.786s.131.523.262.786c.263.261.788.915 1.575 1.7.788.916 2.1 2.093 3.938 3.795 1.837 1.57 3.937 2.878 5.512 4.055.394.263.788.263 1.182 0 .393-.261.525-.523.525-1.046v-4.972c1.706-.262 1.837-.262 3.412-.654s2.494-.655 2.888-.786C20.475 12.823 21 11.776 21 10.468c0-1.44-.525-2.355-1.575-3.01z" })
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = LastVisitedIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LastVisitedPreview() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "108",
	      height: "108",
	      viewBox: "0 0 108 108"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement("path", { fill: "#FFF", d: "M0 0H108V108H0z" }),
	      _react2.default.createElement("path", {
	        fill: "#EFEFEF",
	        d: "M93 98a4 4 0 014 4v6H10v-6a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V73a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V44a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V15a4 4 0 014-4h79z"
	      }),
	      _react2.default.createElement("rect", { width: "31", height: "31", x: "39", y: "38", fill: "currentColor", rx: "4" }),
	      _react2.default.createElement("path", {
	        fill: "#FFF",
	        fillRule: "nonzero",
	        d: "M55.143 59.988a.95.95 0 00.785-.92v-7.037h4.61c.231 0 .462-.222.462-.443a.4.4 0 00-.187-.36l-.008-.006-5.158-4.958c-.331-.352-.922-.352-1.296 0l-5.21 5c-.15.144-.18.303-.093.49.05.166.23.263.425.263h4.611v7.08c0 .539.511.981 1.059.891z",
	        transform: "rotate(-90 55 53)"
	      })
	    )
	  );
	}
	
	exports.default = LastVisitedPreview;
	module.exports = exports["default"];

/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LayersIcon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "22",
	      height: "22",
	      viewBox: "0 0 22 22"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { fill: "#FFF", fillRule: "nonzero", transform: "translate(-170 -1743)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(136 1575)" },
	          _react2.default.createElement(
	            "g",
	            { transform: "translate(34 168)" },
	            _react2.default.createElement("path", { d: "M22 7.333L11 0 0 7.333l11 7.334 11-7.334zM11 18.606L3.056 13.2 0 14.96 11 22l11-7.04-2.933-1.634L11 18.606z" })
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = LayersIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LayersPreview() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "108",
	      height: "108",
	      viewBox: "0 0 108 108"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement("path", { fill: "#FFF", d: "M0 0H108V108H0z" }),
	      _react2.default.createElement("path", {
	        fill: "#EFEFEF",
	        d: "M93 98a4 4 0 014 4v6H10v-6a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V73a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V44a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V15a4 4 0 014-4h79z"
	      }),
	      _react2.default.createElement("rect", {
	        width: "44",
	        height: "44",
	        x: "32.5",
	        y: "32.5",
	        fill: "currentColor",
	        rx: "4"
	      })
	    )
	  );
	}
	
	exports.default = LayersPreview;
	module.exports = exports["default"];

/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TimersIcon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "19",
	      height: "22",
	      viewBox: "0 0 19 22"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { fill: "#FFF", fillRule: "nonzero", transform: "translate(-171 -2143)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(136 1975)" },
	          _react2.default.createElement(
	            "g",
	            { transform: "translate(35 168)" },
	            _react2.default.createElement("path", { d: "M13.563 0c.75 0 1.357.615 1.357 1.374 0 .76-.607 1.375-1.357 1.375H10.85v.11a9.435 9.435 0 014.22 1.745c.075-.178.18-.341.313-.481l.895-.907c.622-.63 1.631-.63 2.253 0 .622.63.622 1.651 0 2.281l-.896.907c-.134.128-.29.23-.461.303a9.718 9.718 0 01-.221 11.64c-2.647 3.389-7.2 4.575-11.134 2.9C1.885 19.573-.463 15.448.077 11.162c.54-4.286 3.835-7.682 8.058-8.303v-.11H5.42c-.75 0-1.357-.616-1.357-1.375S4.671 0 5.42 0zM9.492 5.497c-3.748 0-6.786 3.077-6.786 6.872s3.038 6.872 6.786 6.872c3.747 0 6.785-3.077 6.785-6.872S13.24 5.497 9.492 5.497zM7.035 9.813a.726.726 0 01.978 0l1.357 1.21c.236-.101.49-.153.746-.152 1.15 0 2.085.942 2.09 2.107.005 1.166-.921 2.116-2.072 2.126-1.15.01-2.093-.924-2.108-2.09.002-.267.052-.533.15-.782L6.98 10.857a.692.692 0 01-.19-.536.732.732 0 01.244-.508z" })
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = TimersIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TimersPreview() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "108",
	      height: "108",
	      viewBox: "0 0 108 108"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement("path", { fill: "#FFF", d: "M0 0H108V108H0z" }),
	      _react2.default.createElement("path", {
	        fill: "#EFEFEF",
	        d: "M93 98a4 4 0 014 4v6H10v-6a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V73a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V44a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V15a4 4 0 014-4h79z"
	      }),
	      _react2.default.createElement("rect", { width: "43", height: "30", x: "33", y: "39", fill: "currentColor", rx: "4" }),
	      _react2.default.createElement("path", {
	        fill: "#FFF",
	        fillRule: "nonzero",
	        d: "M44.653 58.568c1.135 0 2.02-.256 2.652-.767.633-.511.949-1.205.949-2.08 0-.598-.165-1.081-.494-1.45-.33-.368-.767-.613-1.313-.734.468-.165.84-.412 1.118-.741.277-.33.416-.754.416-1.274 0-.364-.074-.7-.221-1.008a2.305 2.305 0 00-.637-.799 3.036 3.036 0 00-1.014-.527A4.539 4.539 0 0044.744 49a4.23 4.23 0 00-1.417.221 3.064 3.064 0 00-1.053.611 2.814 2.814 0 00-.682.943c-.16.36-.254.751-.28 1.176h1.859c.052-.442.21-.787.474-1.034.265-.247.618-.37 1.06-.37.433 0 .756.11.968.332.213.22.319.496.319.825 0 .399-.113.704-.338.916-.225.213-.585.319-1.079.319h-.676v1.404h.728c.503 0 .877.11 1.124.331.248.221.371.557.371 1.008 0 .416-.126.743-.377.981-.251.239-.641.358-1.17.358-.563 0-.973-.145-1.229-.435-.255-.29-.405-.661-.448-1.112H41c.043.945.366 1.697.968 2.256.603.559 1.498.838 2.685.838zm14.404-.143v-1.599h-3.614l1.755-1.716c.537-.52.97-1.044 1.3-1.573.33-.529.494-1.1.494-1.716 0-.416-.072-.797-.214-1.144a2.538 2.538 0 00-.618-.897 3.022 3.022 0 00-1.02-.572A4.203 4.203 0 0055.767 49c-1.049 0-1.879.282-2.49.845-.61.563-.942 1.387-.994 2.47h1.911c.07-.615.23-1.053.481-1.313s.585-.39 1.001-.39c.407 0 .715.113.923.338.208.225.312.533.312.923 0 .425-.132.847-.396 1.268a8.9 8.9 0 01-1.073 1.345l-3.406 3.601v.338h7.02zm7.982 0V49.13h-1.846l-2.145 1.521v1.794l1.885-1.235v7.215h2.106z"
	      })
	    )
	  );
	}
	
	exports.default = TimersPreview;
	module.exports = exports["default"];

/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TransitionsIcon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "25",
	      height: "24",
	      viewBox: "0 0 25 24"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { fill: "#FFF", fillRule: "nonzero", transform: "translate(-564 -2143)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(531 1975)" },
	          _react2.default.createElement(
	            "g",
	            { transform: "translate(33 168)" },
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(.5)" },
	              _react2.default.createElement("path", { d: "M9.49 14.51c.672.673.681 1.76.02 2.444L2.976 23.49A1.743 1.743 0 01.51 21.025l6.536-6.536a1.743 1.743 0 012.444.021zM11.089.17a1.556 1.556 0 011.64.141l3.625 2.704 4.13-1.48a1.556 1.556 0 011.976 1.977l-1.456 4.286 2.68 3.47c.36.472.417 1.11.147 1.639-.277.52-.818.847-1.408.85l-4.526-.055-2.476 3.63a1.556 1.556 0 01-2.767-.437l-1.34-4.322-4.208-1.226a1.556 1.556 0 01-.44-2.766l3.7-2.618-.127-4.384a1.556 1.556 0 01.85-1.41z" })
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = TransitionsIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TransitionsPreview() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "108",
	      height: "108",
	      viewBox: "0 0 108 108"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement("path", { fill: "#FFF", d: "M0 0H108V108H0z" }),
	      _react2.default.createElement("path", {
	        fill: "#EFEFEF",
	        d: "M93 98a4 4 0 014 4v6H10v-6a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V73a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V44a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V15a4 4 0 014-4h79z"
	      }),
	      _react2.default.createElement("path", { fill: "currentColor", d: "M52 0H108V108H52z" }),
	      _react2.default.createElement("path", {
	        fill: "#FFF",
	        fillRule: "nonzero",
	        d: "M80.19 65.983a1.333 1.333 0 001.048-1.313V54.615h6.147c.308 0 .615-.316.615-.632 0-.227-.086-.405-.25-.514l-.01-.01-6.877-7.081c-.442-.504-1.23-.504-1.729 0l-6.945 7.14c-.202.208-.24.435-.125.702.068.237.308.375.567.375h6.148V64.71c0 .77.682 1.403 1.412 1.274z",
	        transform: "rotate(-90 80 56)"
	      })
	    )
	  );
	}
	
	exports.default = TransitionsPreview;
	module.exports = exports["default"];

/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Tag;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _generalModule = __webpack_require__(742);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Tag(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _generalModule2.default.tag },
	    children
	  );
	}
	
	Tag.propTypes = {
	  children: _propTypes2.default.node
	};
	module.exports = exports['default'];

/***/ }),

/***/ 742:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tag":"src-components-modules-Tag-style----general-module---tag---2mZkR borderStyle-solid borderColor-smoke fontSize-s borderWidth-1 c-black paddingLeftRight-xs display-inlineFlex justifyContent-center alignItems-center bg-white"};

/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _travelApp2x = __webpack_require__(881);
	
	var _travelApp2x2 = _interopRequireDefault(_travelApp2x);
	
	var _animatedApp2x = __webpack_require__(876);
	
	var _animatedApp2x2 = _interopRequireDefault(_animatedApp2x);
	
	var _financeApp2x = __webpack_require__(878);
	
	var _financeApp2x2 = _interopRequireDefault(_financeApp2x);
	
	var _hotelWebsite2x = __webpack_require__(879);
	
	var _hotelWebsite2x2 = _interopRequireDefault(_hotelWebsite2x);
	
	var _jobsWebsite2x = __webpack_require__(880);
	
	var _jobsWebsite2x2 = _interopRequireDefault(_jobsWebsite2x);
	
	var _doctorApp2x = __webpack_require__(877);
	
	var _doctorApp2x2 = _interopRequireDefault(_doctorApp2x);
	
	var _paths = __webpack_require__(617);
	
	var paths = _interopRequireWildcard(_paths);
	
	var _features = __webpack_require__(472);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var data = [{
	  name: 'Healthcare',
	  title: 'Healthcare app prototype inspiration',
	  description: 'A prototype with multiple flows and chat simulation for on-demand healthcare.',
	  path: paths.DOCTOR_APP,
	  previewImage: _doctorApp2x2.default,
	  prototypeSlug: '6g2c8e0',
	  features: [_features.CONTAINERS, _features.LAYERS, _features.TIMER],
	  isMobile: true,
	  tags: ['Health', 'Chat', 'Mobile']
	}, {
	  name: 'Chat',
	  title: 'Messaging app prototype example',
	  description: 'See how a gamified messaging app can be prototyped before handing off to developers.',
	  path: paths.ANIMATED_CHAT_APP,
	  previewImage: _animatedApp2x2.default,
	  prototypeSlug: 'j9750e',
	  features: [_features.TIMER, _features.GIF],
	  isMobile: true,
	  tags: ['Social Media', 'Gif', 'Timers']
	}, {
	  name: 'Hotel',
	  title: 'Hotel booking app prototype example',
	  description: 'A prototype for finding and booking holiday accommodation.',
	  path: paths.HOTEL_APP,
	  previewImage: _hotelWebsite2x2.default,
	  prototypeSlug: '13g69h4e',
	  features: [_features.EMBED, _features.CONTAINERS, _features.FIXED_HEADER_FOOTER],
	  isMobile: false,
	  tags: ['Travel', 'Website']
	}, {
	  name: 'Travel',
	  title: 'Travel app prototype inspiration | Marvel',
	  description: 'A simple prototype for finding and purchasing holidays.',
	  path: paths.TRAVEL_APP,
	  previewImage: _travelApp2x2.default,
	  prototypeSlug: '13g1eh24',
	  features: [_features.EMBED, _features.TRANSITIONS, _features.FIXED_HEADER_FOOTER],
	  isMobile: true,
	  tags: ['Travel', 'Mobile', 'Booking', 'Maps']
	}, {
	  name: 'Recruitment',
	  title: '',
	  description: 'An example of a desktop prototype for a recruitment website.',
	  path: paths.JOBS_WEBSITE,
	  previewImage: _jobsWebsite2x2.default,
	  prototypeSlug: '5j3628i',
	  features: [_features.EMBED, _features.CONTAINERS, _features.TRANSITIONS],
	  isMobile: false,
	  tags: ['Recruitment', 'Desktop', 'Containers', 'Embeds']
	}, {
	  name: 'Finance',
	  title: 'Banking app prototype example',
	  description: 'A large mobile banking prototype featuring several flows around.',
	  path: paths.FIANCE_APP,
	  previewImage: _financeApp2x2.default,
	  prototypeSlug: '6g00b39',
	  features: [_features.EMBED, _features.CONTAINERS, _features.FIXED_HEADER_FOOTER],
	  isMobile: true,
	  tags: ['Finance', 'Mobile']
	}];
	
	exports.default = data;
	module.exports = exports['default'];

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TRANSITIONS = exports.LAST_VISITED = exports.TIMER = exports.GIF = exports.LAYERS = exports.FIXED_HEADER_FOOTER = exports.EMBED = exports.SCROLL_TO_ANCHOR = exports.LINK = exports.CONTAINERS = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContainersIcon = __webpack_require__(571);
	
	var _ContainersIcon2 = _interopRequireDefault(_ContainersIcon);
	
	var _ContainersPreview = __webpack_require__(572);
	
	var _ContainersPreview2 = _interopRequireDefault(_ContainersPreview);
	
	var _AnchorIcon = __webpack_require__(569);
	
	var _AnchorIcon2 = _interopRequireDefault(_AnchorIcon);
	
	var _AnchorPreview = __webpack_require__(570);
	
	var _AnchorPreview2 = _interopRequireDefault(_AnchorPreview);
	
	var _EmbedIcon = __webpack_require__(573);
	
	var _EmbedIcon2 = _interopRequireDefault(_EmbedIcon);
	
	var _EmbedPreview = __webpack_require__(576);
	
	var _EmbedPreview2 = _interopRequireDefault(_EmbedPreview);
	
	var _EmbedMultimedia = __webpack_require__(574);
	
	var _EmbedMultimedia2 = _interopRequireDefault(_EmbedMultimedia);
	
	var _EmbedMultimediaPreview = __webpack_require__(575);
	
	var _EmbedMultimediaPreview2 = _interopRequireDefault(_EmbedMultimediaPreview);
	
	var _FixedHeaderFooter = __webpack_require__(577);
	
	var _FixedHeaderFooter2 = _interopRequireDefault(_FixedHeaderFooter);
	
	var _FixedHeaderFooterPreview = __webpack_require__(578);
	
	var _FixedHeaderFooterPreview2 = _interopRequireDefault(_FixedHeaderFooterPreview);
	
	var _Layers = __webpack_require__(583);
	
	var _Layers2 = _interopRequireDefault(_Layers);
	
	var _LayersPreview = __webpack_require__(584);
	
	var _LayersPreview2 = _interopRequireDefault(_LayersPreview);
	
	var _Timers = __webpack_require__(585);
	
	var _Timers2 = _interopRequireDefault(_Timers);
	
	var _TimersPreview = __webpack_require__(586);
	
	var _TimersPreview2 = _interopRequireDefault(_TimersPreview);
	
	var _LastVisited = __webpack_require__(581);
	
	var _LastVisited2 = _interopRequireDefault(_LastVisited);
	
	var _LastVisitedPreview = __webpack_require__(582);
	
	var _LastVisitedPreview2 = _interopRequireDefault(_LastVisitedPreview);
	
	var _Transitions = __webpack_require__(587);
	
	var _Transitions2 = _interopRequireDefault(_Transitions);
	
	var _TransitionsPreview = __webpack_require__(588);
	
	var _TransitionsPreview2 = _interopRequireDefault(_TransitionsPreview);
	
	var _Gif = __webpack_require__(579);
	
	var _Gif2 = _interopRequireDefault(_Gif);
	
	var _GifPreview = __webpack_require__(580);
	
	var _GifPreview2 = _interopRequireDefault(_GifPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CONTAINERS = exports.CONTAINERS = 'CONTAINERS';
	var LINK = exports.LINK = 'LINK';
	var SCROLL_TO_ANCHOR = exports.SCROLL_TO_ANCHOR = 'SCROLL_TO_ANCHOR';
	var EMBED = exports.EMBED = 'EMBED';
	var FIXED_HEADER_FOOTER = exports.FIXED_HEADER_FOOTER = 'FIXED_HEADER_FOOTER';
	var LAYERS = exports.LAYERS = 'LAYERS';
	var GIF = exports.GIF = 'GIF';
	var TIMER = exports.TIMER = 'TIMER';
	var LAST_VISITED = exports.LAST_VISITED = 'LINK_LAST_VISITED';
	var TRANSITIONS = exports.TRANSITIONS = 'TRANSITIONS';
	
	var features = [{
	  id: EMBED,
	  name: 'Embed',
	  description: 'Add dynamic content like videos, audio and maps',
	  helpId: '360003855577',
	  icon: _react2.default.createElement(_EmbedMultimedia2.default, null),
	  preview: _react2.default.createElement(_EmbedMultimediaPreview2.default, null),
	  color: '#FFD79B'
	}, {
	  id: TRANSITIONS,
	  name: 'Transitions',
	  description: 'Add realistic animations when transitioning to a hotspot',
	  helpId: '360017013198',
	  icon: _react2.default.createElement(_Transitions2.default, null),
	  preview: _react2.default.createElement(_TransitionsPreview2.default, null),
	  color: '#FF977A'
	}, {
	  id: CONTAINERS,
	  name: 'Containers',
	  description: 'Enable elements to scroll horizontally or vertically',
	  helpId: '360014699118',
	  preview: _react2.default.createElement(_ContainersPreview2.default, null),
	  icon: _react2.default.createElement(_ContainersIcon2.default, null),
	  color: '#AD6EDD'
	}, {
	  id: LINK,
	  name: 'Link',
	  description: 'Link to any external website, document or surveys',
	  helpId: '360003842897',
	  preview: _react2.default.createElement(_EmbedPreview2.default, null),
	  icon: _react2.default.createElement(_EmbedIcon2.default, null),
	  color: '#60D2C9'
	}, {
	  id: SCROLL_TO_ANCHOR,
	  name: 'Scroll to anchor',
	  description: 'Automatically scroll to another area on the same page',
	  helpId: '207646029',
	  icon: _react2.default.createElement(_AnchorIcon2.default, null),
	  preview: _react2.default.createElement(_AnchorPreview2.default, null),
	  color: '#FD6F3C'
	}, {
	  id: FIXED_HEADER_FOOTER,
	  name: 'Fixed header/footer',
	  description: 'Keep the top or bottom of the design fixed while the rest of the screen scrolls',
	  helpId: '209299185',
	  icon: _react2.default.createElement(_FixedHeaderFooter2.default, null),
	  preview: _react2.default.createElement(_FixedHeaderFooterPreview2.default, null),
	  color: '#2A3440'
	}, {
	  id: LAYERS,
	  name: 'Layer an image',
	  description: 'Add elements on top of your screen to recreate modals, tooltips and more',
	  helpId: '209299205',
	  icon: _react2.default.createElement(_Layers2.default, null),
	  preview: _react2.default.createElement(_LayersPreview2.default, null),
	  color: '#FFAE30'
	}, {
	  id: GIF,
	  name: 'Gif Animation',
	  description: 'Add GIFs to create animated areas in your prototype',
	  helpId: '360017022798',
	  icon: _react2.default.createElement(_Gif2.default, null),
	  preview: _react2.default.createElement(_GifPreview2.default, null),
	  color: '#FFC772'
	}, {
	  id: TIMER,
	  name: 'Timers',
	  description: 'Transition between screens after a set amount of time',
	  helpId: '360002731437',
	  icon: _react2.default.createElement(_Timers2.default, null),
	  preview: _react2.default.createElement(_TimersPreview2.default, null),
	  color: '#1FB6FF'
	}, {
	  id: LAST_VISITED,
	  name: 'Link to last visited screen',
	  description: 'Automatically link to the previous screen the user visited',
	  helpId: '360017019778',
	  icon: _react2.default.createElement(_LastVisited2.default, null),
	  preview: _react2.default.createElement(_LastVisitedPreview2.default, null),
	  color: '#60D956'
	}];
	
	exports.default = features;

/***/ }),

/***/ 617:
/***/ (function(module, exports) {

	'use strict';
	
	// When you change this file you need to rerun 'yarn start'
	
	module.exports = Object.freeze({
	  JOBS_WEBSITE: '/examples/recruitment-website',
	  TRAVEL_APP: '/examples/travel-app',
	  FIANCE_APP: '/examples/banking-app',
	  ANIMATED_CHAT_APP: '/examples/animated-chat-app',
	  DOCTOR_APP: '/examples/healthcare-app',
	  HOTEL_APP: '/examples/hotel-app'
	});

/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/animated-app@2x-59ee921d7efeb942898328af0f844d35.jpg";

/***/ }),

/***/ 877:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/doctor-app@2x-ee6d93df970fdd77f6a7b490e8900975.jpg";

/***/ }),

/***/ 878:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/finance-app@2x-174b5f66da977076af3d72acb582dfde.jpg";

/***/ }),

/***/ 879:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hotel-website@2x-d3eb51e790ba854d830efcf5fb66c76a.jpg";

/***/ }),

/***/ 880:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/jobs-website@2x-263884c3c35fd4fbf04b7f0721a058a2.jpg";

/***/ }),

/***/ 881:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/travel-app@2x-13c2fc7be454da82bef3038487d5338e.jpg";

/***/ }),

/***/ 1321:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactRouterDom = __webpack_require__(51);
	
	var _reactRedux = __webpack_require__(38);
	
	var _bind = __webpack_require__(17);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _reactRouterLastLocation = __webpack_require__(852);
	
	var _selectors = __webpack_require__(69);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _tooltip = __webpack_require__(1119);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _data = __webpack_require__(616);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _features = __webpack_require__(472);
	
	var _features2 = _interopRequireDefault(_features);
	
	var _DiagonalArrow = __webpack_require__(1180);
	
	var _DiagonalArrow2 = _interopRequireDefault(_DiagonalArrow);
	
	var _Tag = __webpack_require__(610);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _FullScreen = __webpack_require__(1144);
	
	var _FullScreen2 = _interopRequireDefault(_FullScreen);
	
	var _exampleModule = __webpack_require__(1510);
	
	var _exampleModule2 = _interopRequireDefault(_exampleModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Example(_ref) {
	  var _classNames;
	
	  var location = _ref.location,
	      isLoggedIn = _ref.isLoggedIn;
	
	  var pageData = _data2.default.find(function (example) {
	    return example.path === location.pathname;
	  });
	  var prototypeUrl = 'https://marvelapp.com/prototype/' + pageData.prototypeSlug + '/';
	  var cloneUrl = '/project/clone-bounce/' + pageData.prototypeSlug;
	  var signupAndCopyUrl = '/signup/?next=' + cloneUrl + '/';
	  var signupText = 'Sign up and duplicate';
	  var url = signupAndCopyUrl;
	  if (isLoggedIn) {
	    url = cloneUrl;
	    signupText = 'Duplicate to your workspace';
	  }
	  var featuresData = pageData.features.map(function (featureConstant) {
	    return _features2.default.find(function (feature) {
	      return feature.id === featureConstant;
	    });
	  });
	  var withoutCurrent = _data2.default.filter(function (example) {
	    return example.path !== location.pathname;
	  });
	  var randomExamples = withoutCurrent.sort(function () {
	    return Math.random() - Math.random();
	  }).slice(0, 5);
	
	  var playerClassName = (0, _bind2.default)(_exampleModule2.default.player, (_classNames = {}, _classNames['' + _exampleModule2.default.playerMobile] = pageData.isMobile, _classNames));
	
	  var meta = {
	    title: pageData.title + ' | Marvel',
	    meta: [{
	      name: 'description',
	      content: pageData.description
	    }],
	    banner: true,
	    header: true,
	    footer: true
	  };
	
	  return _react2.default.createElement(
	    _Page2.default,
	    meta,
	    _react2.default.createElement(
	      'div',
	      { className: _exampleModule2.default.wrap },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: _exampleModule2.default.headingPrefix, to: '/examples' },
	        'Example prototype'
	      ),
	      _react2.default.createElement(
	        'h1',
	        { className: _exampleModule2.default.heading },
	        pageData.name
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: _exampleModule2.default.subheading },
	        pageData.description
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _exampleModule2.default.tags },
	        pageData.tags.map(function (tag) {
	          return _react2.default.createElement(
	            'div',
	            { className: _exampleModule2.default.tag, key: tag },
	            _react2.default.createElement(
	              _Tag2.default,
	              null,
	              tag
	            )
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: playerClassName },
	        _react2.default.createElement('iframe', {
	          className: _exampleModule2.default.iframe,
	          frameBorder: '0',
	          allowTransparency: 'true',
	          height: '600',
	          width: '100%',
	          src: prototypeUrl + '?exp=1&iosapp=true'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _exampleModule2.default.actions },
	          _react2.default.createElement(
	            'a',
	            {
	              className: _exampleModule2.default.button,
	              href: url,
	              target: '_blank',
	              rel: 'noreferrer',
	              'data-testid': 'duplicate-to-workspace'
	            },
	            _react2.default.createElement(
	              _button2.default,
	              {
	                shape: 'rounded',
	                kind: 'outlined',
	                hover: 'blue',
	                size: 'medium',
	                background: 'white'
	              },
	              signupText
	            )
	          ),
	          _react2.default.createElement(
	            _tooltip2.default,
	            { text: 'Open in new window', size: 'medium' },
	            _react2.default.createElement(
	              'a',
	              {
	                href: prototypeUrl,
	                target: '_blank',
	                rel: 'noreferrer',
	                'data-testid': 'open-in-new-window'
	              },
	              _react2.default.createElement(_button2.default, {
	                shape: 'rounded',
	                kind: 'outlined',
	                hover: 'green',
	                size: 'medium',
	                icon: _react2.default.createElement(_FullScreen2.default, null),
	                background: 'white'
	              })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: _exampleModule2.default.features },
	          'Features used'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _exampleModule2.default.grid },
	          featuresData.map(function (feature) {
	            return _react2.default.createElement(
	              'div',
	              { className: _exampleModule2.default.feature, key: feature.id },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: _exampleModule2.default.preview,
	                  style: { color: feature.color }
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: _exampleModule2.default.previewIcon },
	                  feature.preview
	                ),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: _exampleModule2.default.featureIcon,
	                    style: { backgroundColor: feature.color }
	                  },
	                  feature.icon
	                )
	              ),
	              _react2.default.createElement(
	                'h3',
	                { className: _exampleModule2.default.featureName },
	                feature.name
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: _exampleModule2.default.featureDescription },
	                feature.description
	              ),
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'https://help.marvelapp.com/hc/en-us/articles/' + feature.helpId,
	                  className: _exampleModule2.default.readDocumentation,
	                  target: '_blank',
	                  rel: 'noreferrer'
	                },
	                'Read Tutorial',
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: _exampleModule2.default.arrow },
	                  _react2.default.createElement(_DiagonalArrow2.default, null)
	                )
	              )
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: _exampleModule2.default.morePrototypes },
	        'More prototypes'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _exampleModule2.default.morePrototypesGrid },
	        randomExamples.map(function (feature) {
	          return _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: feature.path, key: feature.id },
	            _react2.default.createElement(
	              'div',
	              { className: _exampleModule2.default.previewImage },
	              _react2.default.createElement(_Image2.default, { src: feature.previewImage, hasShadow: false })
	            )
	          );
	        })
	      )
	    )
	  );
	}
	
	Example.propTypes = {
	  location: _propTypes2.default.object,
	  isLoggedIn: _propTypes2.default.bool,
	  history: _propTypes2.default.object.isRequired,
	  lastLocation: _propTypes2.default.object
	};
	
	function mapStateToProps(state) {
	  return {
	    isLoggedIn: (0, _selectors.isUserLoggedIn)(state)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactRouterLastLocation.withLastLocation)((0, _reactRouterDom.withRouter)(Example)));
	module.exports = exports['default'];

/***/ }),

/***/ 1510:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrap":"src-templates-style----example-module---wrap---arEjC pageWrap c-black pageWrap-l","player":"src-templates-style----example-module---player---U_8r2 borderRadius-l paddingLeft-l paddingRight-l paddingTop-l overflow-hidden position-relative bg-snow","playerMobile":"src-templates-style----example-module---playerMobile---RLHSi padding-l","heading":"src-templates-style----example-module---heading---16I2g fontWeight-6 marginTop-s marginBottom-xs fontSize-xxxl textAlign-left lineHeight-title breakPointS-fontSize-xxxl breakPointM-fontSize-xxxxl","headingPrefix":"src-templates-style----example-module---headingPrefix---1Y0XS marginBottom-s letterSpacing-m fontWeight-5 textTransform-uppercase fontSize-xs lineHeight-title transitionDuration-m transitionProperty-all cursor-pointer transitionTimingFunction-linear c-slate c-blue--d--hover textDecoration-none breakPointS-fontSize-s breakPointM-fontSize-m","subheading":"src-templates-style----example-module---subheading---2_jqu fontSize-l lineHeight-copy c-slate textAlign-left marginBottom-m breakPointS-fontSize-xl breakPointM-fontSize-xxl breakPointM-lineHeight-xxl fontWeight-4","iframe":"src-templates-style----example-module---iframe---27HdX width-100","actions":"src-templates-style----example-module---actions---2UJtu paddingBottom-m paddingRight-m position-absolute","button":"src-templates-style----example-module---button---3XoQB marginRight-xs","preview":"src-templates-style----example-module---preview---3-RYY display-flex position-relative justifyContent-center alignItems-center borderRadius-l bg-snow","grid":"src-templates-style----example-module---grid---34y7R c-black textAlign-center","features":"src-templates-style----example-module---features---291_W fontSize-l lineHeight-copy c-black textAlign-left marginTop-l marginBottom-l breakPointS-fontSize-xl breakPointM-fontSize-xxl breakPointM-lineHeight-xl fontWeight-6","feature":"src-templates-style----example-module---feature---21prC textAlign-left","featureIcon":"src-templates-style----example-module---featureIcon---1Tnp3 position-absolute borderRadius-l display-flex justifyContent-center alignItems-center marginLeft-m marginBottom-m","previewIcon":"src-templates-style----example-module---previewIcon---3i_2o overflow-hidden borderRadius-l","featureName":"src-templates-style----example-module---featureName---2XIOb fontSize-s lineHeight-copy c-black textAlign-left marginTop-s breakPointS-fontSize-m breakPointM-fontSize-l fontWeight-6","featureDescription":"src-templates-style----example-module---featureDescription---16-OH fontSize-s lineHeight-copy c-black textAlign-left marginTop-xxs breakPointS-fontSize-m breakPointM-fontSize-l breakPointM-lineHeight-s","readDocumentation":"src-templates-style----example-module---readDocumentation---1vDV_ marginTop-s fontSize-s textDecoration-none c-marvel--d justifyContent-center paddingLeftRight-xs alignItems-center display-inlineFlex","arrow":"src-templates-style----example-module---arrow---F2EUp display-flex marginLeft-xxs","morePrototypes":"src-templates-style----example-module---morePrototypes---2R_fA fontSize-l lineHeight-copy c-black textAlign-left marginTop-l marginBottom-l breakPointS-fontSize-xl breakPointM-fontSize-xxl breakPointM-lineHeight-xl fontWeight-6","morePrototypesGrid":"src-templates-style----example-module---morePrototypesGrid---3GF9q c-black marginBottom-xl textAlign-center","previewImage":"src-templates-style----example-module---previewImage---1yRz4 overflow-hidden opacity-80--hover borderRadius-l","tags":"src-templates-style----example-module---tags---24i_A textAlign-left marginBottom-l","tag":"src-templates-style----example-module---tag---38CSv display-inlineBlock marginRight-xs"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-example-js-b42df2469fb081dcd953.js